// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:01:32.195Z
// Property: Parc South Mountain (ID: 6767906449166443)
// Collections: 22 amenities, 3 floorplans (live), 33 photos, 51 POIs, 4 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166443",
  "property_external_id": "2s1lm38",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/parc-south-mountain/CkB9ky/",
  "property_apartments_url": "https://www.apartments.com/parc-south-mountain-phoenix-az/2s1lm38/",
  "property_google_business_url": "https://www.google.com/maps/place/Parc+South+Mountain/data=!4m2!3m1!1s0x0:0x4d11409323227fda?sa=X&ved=2ahUKEwivvom446eSAxVWmq8BHapuEM4Q_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40248123705",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "243PSM",
  "property_status": null,
  "property_slug": "parc-south-mountain",
  "property_name": "Parc South Mountain",
  "property_website_url": "https://www.parcsouthmountain.com/",
  "property_domain": "https://www.parcsouthmountain.com/",
  "property_address": "3400 East Southern Avenue",
  "property_full_address": "3400 E Southern Ave, Phoenix, AZ 85040",
  "property_address_1": "3400 E Southern Ave",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85040",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "South Mountain Village",
  "property_address_latitude": "33.3957033",
  "property_address_longitude": "-112.008569",
  "property_email": null,
  "property_phone": "(602) 960-4344",
  "property_call_tracking_phone": "844-732-3716",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Parc South Mountain, where modern comfort meets luxury in Phoenix, AZ. Choose from spacious one, two, or three-bedroom floor plans, each featuring gourmet kitchens and high-end finishes. Enjoy exclusive amenities like our resort-style pool, dog park, and 24/7 fitness center. Your perfect home awaits—check availability or schedule a tour today!",
  "property_long_description": "Welcome to Parc South Mountain, your ideal oasis in the heart of Phoenix, AZ. Our stunning apartment community offers an array of thoughtfully designed floor plans, including one, two, and three-bedroom options, tailored to suit your lifestyle. Each apartment features modern touches like wood-inspired flooring, gourmet kitchens with quartz countertops, and stainless steel appliances, complemented by luxurious bathrooms with high-end finishes.\n\nParc South Mountain is more than just a place to live; it’s a vibrant community packed with resort-style amenities. Dive into relaxation at our resort-inspired pool and spa, and unwind by the outdoor sitting spaces, complete with a double-sided fireplace. For our furry residents, we have a dedicated dog park and a convenient pet wash room. Enjoy the ease of covered parking and Amazon parcel lockers, and rest assured with 24-hour emergency maintenance for your peace of mind.\n\nStay active in our state-of-the-art fitness center equipped with interactive technology, or gather with friends in our spacious resident clubhouse featuring a pool table and TV lounge. With free Wi-Fi in all common areas and a gated community boasting key-fob access, you’ll enjoy both security and connectivity.\n\nAt Parc South Mountain, we’ve crafted a lifestyle designed for comfort and convenience. With features like personal balconies, spacious walk-in closets, and high-capacity washers and dryers in every home, you'll feel right at home.\n\nFind your new home today—browse our availability or schedule a tour to experience the beauty and comfort of Parc South Mountain firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019f6b9b-1881-7459-958e-24eadfa66249.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool and spa with palm trees and lounge chairs.",
    "public_id": "019f6b9b-1881-7459-958e-24eadfa66249",
    "storage_key": "property/6767906449166443/019f6b9b-1881-7459-958e-24eadfa66249.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166443/019ffc3a-c257-72eb-9fab-b87088f4850a.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3a-c257-72eb-9fab-b87088f4850a",
    "storage_key": "property/6767906449166443/019ffc3a-c257-72eb-9fab-b87088f4850a.m4v",
    "thumbnail_key": "property/6767906449166443/019ffc3a-c257-72eb-9fab-b87088f4850a_thumb.webp",
    "size_bytes": 16555797,
    "classification": "Community",
    "title": "Discover Luxury Living: Pool, Gym, and Amenities at [Community Name]",
    "description": "Explore our resort-style pool, state-of-the-art fitness center, and resident lounge. Experience the best of community living."
  },
  "property_total_units": "258",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.51162790697676",
  "property_admin_fee": "300",
  "property_application_fee": "65",
  "property_fees_deposit_info": "Security Deposit\n$300-Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": "no aggressive breeds",
  "property_pet_policy_description": "Pets allowed: cats and dogs only, up to 2 pets per unit. Maximum weight per pet: 80 lb. One-time pet fee: $200. Monthly pet rent: $30 per pet. Deposit: $200 per pet. Restrictions: no aggressive breeds.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://parcsouthmountain.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcparcsouthmountain",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-9b12-757a-95ab-0342cfc09f6f.webp",
  "property_primary_logo_media": {
    "alt_text": "Parc South Mountain logo.",
    "public_id": "019d02cc-9b12-757a-95ab-0342cfc09f6f",
    "storage_key": "property/6767906449166443/019d02cc-9b12-757a-95ab-0342cfc09f6f.webp",
    "width": 460,
    "height": 140
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-868b-77aa-9dec-f13e595bab34.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02cc-868b-77aa-9dec-f13e595bab34",
    "storage_key": "property/6767906449166443/019d02cc-868b-77aa-9dec-f13e595bab34.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-a762-74be-bb5d-96a6f94f2a1c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Parc South Mountain logo",
    "public_id": "019d02cc-a762-74be-bb5d-96a6f94f2a1c",
    "storage_key": "property/6767906449166443/019d02cc-a762-74be-bb5d-96a6f94f2a1c.webp",
    "width": 460,
    "height": 140
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-9b12-757a-95ab-0342cfc09f6f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Parc South Mountain logo.",
    "public_id": "019d02cc-9b12-757a-95ab-0342cfc09f6f",
    "storage_key": "property/6767906449166443/019d02cc-9b12-757a-95ab-0342cfc09f6f.webp",
    "width": 460,
    "height": 140
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "726 - 1244",
  "property_sqft_min": "726",
  "property_sqft_max": "1244",
  "property_price_range": "$1468 - $2225",
  "property_price_min": "1468",
  "property_price_max": "2225",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/ParcSouthMountain",
  "property_instagram_url": "https://www.instagram.com/parc_southmountain/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJWVos4dUPK4cR2n8iI5NAEU0",
  "property_youtube_url": "https://www.youtube.com/watch?v=cTBzzghV6BU",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=S+7th+St%2C+Phoenix",
  "property_tiktok_url": "https://www.tiktok.com/discover/parc-south-mountain-phoenix-review",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Parc South Mountain",
  "property_home_romance_title": "Embrace Life in Your Perfect Apartment Retreat Today",
  "property_home_amenities_blurb": "Welcome to Parc South Mountain, your haven in Phoenix, AZ. Choose from one, two, and three-bedroom floor plans designed for modern living. Enjoy luxurious touches like gourmet kitchens, resort-inspired pools, and a vibrant clubhouse. Embrace a lifestyle where comfort meets convenience, all within a gated community. Your perfect home awaits!",
  "property_home_floorplans_blurb": "At Parc South Mountain in Phoenix, AZ, our thoughtfully designed apartment homes cater to diverse lifestyles and tastes. With a variety of spacious floor plans, you’re sure to find a comfortable retreat that feels just right. Browse our available options today and start envisioning your new home!",
  "property_home_gallery_blurb": "Welcome to Parc South Mountain, where modern luxury meets everyday convenience in sunny Phoenix, AZ. Our thoughtfully designed one, two, and three-bedroom apartments feature gourmet kitchens, spacious walk-in closets, and personal balconies. Enjoy premium amenities like a resort-style pool, state-of-the-art fitness center, and a dog park. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Phoenix, Parc South Mountain offers more than just stylish one, two, and three-bedroom apartments. Immerse yourself in vibrant local culture with easy access to Arizona State University, serene parks, and the enriching Phoenix Zoo. Experience the ultimate blend of comfort and community living. ",
  "property_home_reviews_blurb": "Welcome to Parc South Mountain, where residents rave about the \"amazing sense of community\" amid stunning mountain views. Nestled in vibrant Phoenix, AZ, our apartments offer more than just a home; they foster connections and experiences. Check out what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Parc South Mountain, vibrant living meets adventure right outside your door. Enjoy the convenience of nearby hotspots like Arizona State University, Papago Park, and the Desert Botanical Garden. With elegant one, two, and three-bedroom floor plans, your spacious retreat awaits. Dive into the energy of Phoenix living today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Parc South Mountain, your ideal home awaits amidst luxurious design and exceptional amenities. Choose from spacious one, two, or three-bedroom floor plans, featuring gourmet kitchens and plush carpeting. Unwind at our resort-style pool or in our expansive clubhouse. Elevate your lifestyle in Phoenix, AZ, where comfort meets convenience.",
  "property_applynow_blurb": "At Parc South Mountain in Phoenix, find a living space tailored to your lifestyle. Choose from inviting one, two, or three-bedroom floor plans with gourmet kitchens and personal balconies. Enjoy resort-style amenities, including a rejuvenating pool, modern fitness center, and a welcoming dog park. Secure your new home online today!",
  "property_contactus_blurb": "At Parc South Mountain in vibrant Phoenix, AZ, you'll find the perfect home tailored to your lifestyle. Choose from our stylish one, two, or three-bedroom floor plans, each designed for comfort and convenience. Have questions? Our leasing team is ready to assist you. Connect with us today!",
  "property_faqs_blurb": "At Parc South Mountain in Phoenix, AZ, we offer a variety of thoughtfully designed floor plans catering to your lifestyle—including one, two, and three-bedroom options. Have questions? Our FAQs page is your go-to resource for everything you need to know about our vibrant community. Let’s make your move seamless!",
  "property_floorplans_blurb": "At Parc South Mountain in Phoenix, AZ, your ideal living space awaits—choose from stunning one, two, or three-bedroom floor plans designed for comfort and style. Each layout offers unique features to fit your lifestyle. Browse our available apartment homes and step into your dream oasis today!",
  "property_gallery_blurb": "At Parc South Mountain in Phoenix, your dream apartment awaits! Imagine life in our vibrant community, featuring spacious one to three-bedroom floor plans and upscale amenities like a resort-style pool, a dog park, and a 24/7 fitness center. Picture yourself living here—luxury, comfort, and style intertwine!",
  "property_interactivemap_blurb": "At Parc South Mountain, Phoenix's vibrant lifestyle awaits you! Choose from thoughtfully designed one, two, or three-bedroom apartments featuring gourmet kitchens and luxurious bathrooms. Enjoy amenities like a resort-style pool, state-of-the-art fitness center, and pet-friendly dog park. Use our interactive community map to find your new home today!",
  "property_pets_blurb": "At Parc South Mountain in vibrant Phoenix, AZ, your furry companions are cherished. With spacious apartments accommodating up to two pets, including cats and dogs under 80 lbs, your pets will thrive just as you do. Embrace life in a community that understands the bond between you and your pets!",
  "property_referafriend_blurb": "At Parc South Mountain in Phoenix, AZ, our diverse floor plans cater to every lifestyle, offering one, two, and three-bedroom options. Your dream apartment awaits. Plus, great friends make great neighbors—invite a friend to experience the vibrant community and stunning views today! ",
  "property_residentaccess_blurb": "Welcome to Parc South Mountain, where contemporary living meets desert charm in Phoenix, AZ. Choose from stylish one, two, or three-bedroom floor plans designed for comfort. Log in to your resident portal to seamlessly pay rent, schedule maintenance, and enhance your living experience today!",
  "property_reviews_blurb": "At Parc South Mountain in Phoenix, AZ, residents rave about the vibrant community atmosphere, stating, “The friendly neighbors and beautiful surroundings make it feel like home.” Dive into our reviews to uncover more about the exceptional living experience we offer. See what our residents have to say about living at our community!",
  "property_created_at": "1759782574130",
  "property_scheduletour_blurb": "At Parc South Mountain in Phoenix, AZ, our thoughtfully designed one, two, and three-bedroom floor plans promise comfort and style. Ready to envision your new home? Schedule a tour today and listen to our residents share their stories about life in our vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out to Parc South Mountain in vibrant Phoenix, AZ! We offer a variety of spacious floor plans, including one, two, and three-bedroom options, designed to fit your lifestyle. Keep an eye on your inbox—our friendly team will be in touch soon to assist you further!",
  "property_virtualtours_blurb": "At Parc South Mountain in sunny Phoenix, AZ, we offer thoughtfully designed one, two, and three-bedroom apartments that elevate your living experience. Imagine enjoying breathtaking views and modern amenities. Take a virtual tour today and envision your future in our vibrant community! Your perfect home awaits!",
  "property_copyright": "2025 All Rights Reserved. Parc South Mountain",
  "property_seo_title_home": "Parc South Mountain |  Apartments in Phoenix, AZ",
  "property_seo_description_home": "Discover Parc South Mountain in Phoenix, AZ! Choose from luxury one to three-bedroom apartments with top amenities and a convenient location. Tour today!",
  "property_seo_title_floorplans": "Floor Plans | Luxury Apartments Phoenix, AZ",
  "property_seo_description_floorplans": "Find your ideal space at Parc South Mountain in Phoenix, AZ. Choose from stylish one, two, or three-bedroom floor plans. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Apartments in South Phoenix",
  "property_seo_description_amenities": "Experience life at Parc South Mountain in Phoenix, AZ, with a swimming pool, clubhouse, fitness center, and more. Discover your perfect home today!",
  "property_seo_title_gallery": "Gallery | Luxury Apartments in Phoenix, AZ",
  "property_seo_description_gallery": "Experience life at Parc South Mountain in Phoenix, AZ. Dive into our swimming pool, explore the community, or savor stylish interiors. Picture your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Apartments in South Phoenix",
  "property_seo_description_virtualtours": "Experience the charm of Parc South Mountain in Phoenix, AZ! Take a virtual tour and find your perfect one, two, or three-bedroom apartment today!",
  "property_seo_title_interactivemap": "Interactive Map | Parc South Mountain Apartments",
  "property_seo_description_interactivemap": "Discover your haven at Parc South Mountain! Explore spacious floor plans and premier amenities on our interactive map in Phoenix, AZ!",
  "property_seo_title_neighborhood": "Neighborhood | Pet Friendly Apartments in Phoenix, AZ",
  "property_seo_description_neighborhood": "Explore the lively neighborhood around Parc South Mountain in Southeast Phoenix, AZ, and discover local gems and amenities for your ideal community vibe!",
  "property_seo_title_contact": "Contact Us | Apartment Complexes in Phoenix, AZ",
  "property_seo_description_contact": "Experience the perfect home at Parc South Mountain in Phoenix, AZ. Whether you seek a cozy one-bedroom or a spacious three-bedroom, we're here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Find answers to your questions about Parc South Mountain in Phoenix, AZ. Learn about our luxurious amenities and flexible floor plans that suit your lifestyle!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Experience life at Parc South Mountain in Phoenix, AZ! From luxurious amenities to spacious floor plans, see why our residents love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in South Phoenix, AZ",
  "property_seo_description_applynow": "Spacious 1, 2, and 3-bedroom floor plans are waiting for you at Parc South Mountain. Your new home is at your fingertips. Apply now!",
  "property_seo_title_residentaccess": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_residentaccess": "Experience upscale living at Parc South Mountain! Choose from spacious one, two, or three-bedroom apartments with luxury amenities, all in vibrant Phoenix, AZ.",
  "property_seo_title_referafriend": "Refer A Friend | Parc South Mountain",
  "property_seo_description_referafriend": "Invite friends to join you at Parc South Mountain! Enjoy the vibrant Phoenix lifestyle together. Refer a friend today and create lasting memories!",
  "property_seo_title_scheduletour": "Schedule a Tour | Luxury Apartments in South Phoenix",
  "property_seo_description_scheduletour": "Experience vibrant living at Parc South Mountain in Phoenix. Schedule your tour today and step into a lifestyle where comfort meets the beauty of nature!",
  "property_seo_title_privacy": "Privacy Policy | Parc South Mountain",
  "property_seo_description_privacy": "At Parc South Mountain, your privacy matters. Discover our privacy policy that safeguards your personal information—trust us to keep your data safe!",
  "property_seo_title_accessibility": "Website Accessibility | Parc South Mountain",
  "property_seo_description_accessibility": "At Parc South Mountain in Phoenix, we focus on digital inclusion and accessibility so everyone can enjoy community, comfort, and ease.",
  "property_seo_title_sitemap": "Sitemap | Parc South Mountain",
  "property_seo_description_sitemap": "Uncover the hidden gems of Parc South Mountain in Phoenix, AZ! Navigate our sitemap for a seamless journey through your future home and community.",
  "property_seo_title_thankyou": "Thank You | Parc South Mountain | Phoenix, AZ",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of the Parc South Mountain team will connect with you soon. Experience vibrant living in Phoenix, AZ.",
  "property_seo_title_pets": "Pets | Pet Friendly Apartments in Phoenix, AZ",
  "property_seo_description_pets": "At Parc South Mountain in vibrant Phoenix, your furry companions are cherished. Embrace life in a community that understands the bond between you and your pets!",
  "property_updated_at": "1786643140576",
  "amenities": [
    {
      "id": "custom_b15bddd9-464f-4c91-8995-ed4615aa907f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_084a17c2-318e-49a9-ba8b-20b7c227d81d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d4445207-409f-49d7-a083-1dcb2b1452a7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Amazon Parcel Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a7301358-458a-4e10-8a49-d4af3a37fdc6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_98c1c7aa-63a9-4120-a262-c4f5b6847b2f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Inspired Pool and Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7ffb0c53-2f05-4465-9a79-6d9adc35f6ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Large Resident Clubhouse with Pool Table and TV Lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ccde92aa-505a-4645-bedb-e160d85d625e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Sitting Spaces with Double Sided Fireplace",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_eff0b10c-29b6-451b-82e2-3280a9cfe567",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "State-of-the Art Fitness Center with Interactive Equipment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a265f051-a177-4689-83b6-81a9136e3b65",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Free Wi-Fi in all Common Areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7aa755fa-e84b-4e4a-a2da-9065bab16604",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Wash Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_96fcee15-e2b1-444d-91d7-866e8227b727",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community with Key-fob Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1655b360-debb-42b5-bc1e-f611793dcceb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Inspired Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6485d563-7d55-4568-bb0f-17414cfb88b5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Under-Mount Kitchen Sinks",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1f66eb7d-de96-4507-8af9-f0b154e5ff21",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Kitchens with Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4f9f01ba-e3ca-4ee7-9c67-548000000cb6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a258babc-6d95-4283-8b41-e6eaa2b6dd89",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Walk In Closets*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_319ee249-6bdc-4a97-856b-77432abb62e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Designer Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_55b38e60-4c25-4ffb-9e35-494f59c6d1ae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Pendant Lighting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fe2363b6-57cf-462e-b823-3d0fe4917f6a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Personal Balconies",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e9be5854-d8df-4cc0-aa9c-d3e6a5c7fee6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Luxurious Bathrooms w/ High End Finishes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1d6fa741-7836-4277-8581-e9b19511345c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "High Capacity Washer & Dryer in Every Home",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f37c05c0-44e5-412d-8f37-26eb6f09aaeb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "external_id": "false",
      "title": "Additional Storage Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_5045f897-1dc2-4557-aa75-8b1be027fac4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01116-21a1-7434-bfd9-2e1344491969.webp",
      "image_media": {
        "alt_text": "Exterior of modern apartment buildings with balconies and colorful facades at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01116-21a1-7434-bfd9-2e1344491969",
        "storage_key": "property/6767906449166443/01a01116-21a1-7434-bfd9-2e1344491969.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience modern living in these stylish apartment buildings, featuring unique architectural details and vibrant exterior colors.",
      "link": "",
      "alt_text": "Exterior of modern apartment buildings with balconies and colorful facades at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e2ae9d1b-8dd8-4255-91c3-c2c332dfcf27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01116-03c9-73ac-8b79-ca4f9dc037d8.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with stucco facade and modern architecture at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01116-03c9-73ac-8b79-ca4f9dc037d8",
        "storage_key": "property/6767906449166443/01a01116-03c9-73ac-8b79-ca4f9dc037d8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring a stucco facade and clean lines, set against a clear blue sky. Landscaped grounds with trees and artificial turf add to the property's appeal.",
      "link": "",
      "alt_text": "Exterior of apartment building with stucco facade and modern architecture at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6891dc66-4a7b-4122-a42b-9d08da7274f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-beb3-7230-a956-a1d122237f59.webp",
      "image_media": {
        "alt_text": "Parc South Mountain Luxury Apartments building exterior with a palm tree.",
        "public_id": "01a01115-beb3-7230-a956-a1d122237f59",
        "storage_key": "property/6767906449166443/01a01115-beb3-7230-a956-a1d122237f59.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of Parc South Mountain Luxury Apartments. This modern building features a stucco facade with blue and tan accents and balconies on each level. A palm tree and landscaping provide a tropical feel.",
      "link": "",
      "alt_text": "Parc South Mountain Luxury Apartments building exterior with a palm tree.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_467e4989-bc3d-47f3-bcfb-20ba14a022db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-8d72-7468-b6b3-1d5051c86415.webp",
      "image_media": {
        "alt_text": "Modern lounge area with seating, a communal table, and a feature wall with a \"PARC IT\" sign at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-8d72-7468-b6b3-1d5051c86415",
        "storage_key": "property/6767906449166443/01a01115-8d72-7468-b6b3-1d5051c86415.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the stylish and comfortable lounge area, perfect for socializing or working, featuring a rustic wood accent wall and modern furnishings.",
      "link": "",
      "alt_text": "Modern lounge area with seating, a communal table, and a feature wall with a \"PARC IT\" sign at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39c11445-cbf1-4925-8067-99eb48b5d143",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-9d17-7004-845d-3e73a5c7e8cf.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with a long island bar, comfortable seating, and rustic wood accent wall at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-9d17-7004-845d-3e73a5c7e8cf",
        "storage_key": "property/6767906449166443/01a01115-9d17-7004-845d-3e73a5c7e8cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy relaxing and socializing in our stylish communal lounge, featuring a sleek island bar, plush seating, and a warm, rustic wood-paneled accent wall. Perfect for gatherings or unwinding.",
      "link": "",
      "alt_text": "Modern communal lounge area with a long island bar, comfortable seating, and rustic wood accent wall at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7aadbbf0-b7ec-40a0-915c-59dd36a9ae49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-7a80-76f0-ad45-d40a030ca02c.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating, a large television displaying a green spiral, and a bar with stools at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-7a80-76f0-ad45-d40a030ca02c",
        "storage_key": "property/6767906449166443/01a01115-7a80-76f0-ad45-d40a030ca02c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a large TV and a full-service bar, perfect for unwinding or entertaining guests.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating, a large television displaying a green spiral, and a bar with stools at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da796548-96b8-413c-945a-9c547b6557b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-48be-75c5-84dc-f9fe349ed076.webp",
      "image_media": {
        "alt_text": "Billiard table and lounge area with TV in multifamily property's common space at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-48be-75c5-84dc-f9fe349ed076",
        "storage_key": "property/6767906449166443/01a01115-48be-75c5-84dc-f9fe349ed076.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of billiards or relax in the lounge area featuring a large TV, comfortable seating, and stylish decor in this multifamily property's common space.",
      "link": "",
      "alt_text": "Billiard table and lounge area with TV in multifamily property's common space at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f02a045c-6a14-400c-ab2c-5e903af054a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01116-2391-758e-b4cb-a20c4350bb47.webp",
      "image_media": {
        "alt_text": "Gym with free weights, weight machines, treadmills, and stationary bikes at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01116-2391-758e-b4cb-a20c4350bb47",
        "storage_key": "property/6767906449166443/01a01116-2391-758e-b4cb-a20c4350bb47.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio machines, free weights, and strength training equipment.",
      "link": "",
      "alt_text": "Gym with free weights, weight machines, treadmills, and stationary bikes at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_651f4118-ccef-49d8-a0f4-de4bc4bee9d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01116-1326-76f9-b4e3-0529f203146b.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "01a01116-1326-76f9-b4e3-0529f203146b",
        "storage_key": "property/6767906449166443/01a01116-1326-76f9-b4e3-0529f203146b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style pool and spa, complete with ample lounge seating and shaded umbrellas.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool and hot tub area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a4976c0-855b-436a-8307-00d54006c1e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01116-1c15-72fe-a9b0-f9f7abb70d13.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01116-1c15-72fe-a9b0-f9f7abb70d13",
        "storage_key": "property/6767906449166443/01a01116-1c15-72fe-a9b0-f9f7abb70d13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and lush palm trees for a resort-like experience.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c4e94c9-6276-441e-b1c7-b113d768fb61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01116-2553-74bd-88fc-eb413aa7c2bc.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with lounge chairs, blue cushioned seating, and a modern gas fire pit.",
        "public_id": "01a01116-2553-74bd-88fc-eb413aa7c2bc",
        "storage_key": "property/6767906449166443/01a01116-2553-74bd-88fc-eb413aa7c2bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling pool or gather around the fire pit in our inviting outdoor lounge area. Perfect for enjoying sunny days and cool evenings.",
      "link": "",
      "alt_text": "Outdoor pool area with lounge chairs, blue cushioned seating, and a modern gas fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_670bf566-5da5-4f41-a09c-6102526a7f65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-97c1-722f-b763-cd4efb23a1da.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with grills and a long counter with bar stools next to a grassy courtyard.",
        "public_id": "01a01115-97c1-722f-b763-cd4efb23a1da",
        "storage_key": "property/6767906449166443/01a01115-97c1-722f-b763-cd4efb23a1da.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our spacious outdoor kitchen, featuring built-in grills and ample seating, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Outdoor kitchen with grills and a long counter with bar stools next to a grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96c556f6-4c5a-4d73-b5d4-880142ef53d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-3829-7419-831c-1adb3b420c98.webp",
      "image_media": {
        "alt_text": "Ping pong table with paddles and ball on an outdoor patio with benches and courtyard view at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-3829-7419-831c-1adb3b420c98",
        "storage_key": "property/6767906449166443/01a01115-3829-7419-831c-1adb3b420c98.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly game of ping pong on our outdoor patio, perfect for residents looking to socialize and have fun.",
      "link": "",
      "alt_text": "Ping pong table with paddles and ball on an outdoor patio with benches and courtyard view at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_49050998-7ea9-4b50-9c06-1904f7557fcf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01116-2d2f-7778-89c6-9f190ee6c028.webp",
      "image_media": {
        "alt_text": "Dog park with artificial turf, shaded seating area, and covered parking.",
        "public_id": "01a01116-2d2f-7778-89c6-9f190ee6c028",
        "storage_key": "property/6767906449166443/01a01116-2d2f-7778-89c6-9f190ee6c028.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with artificial turf and shaded seating for your convenience. Covered parking is also available.",
      "link": "",
      "alt_text": "Dog park with artificial turf, shaded seating area, and covered parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15cec217-70af-402f-ab9f-6f04193cdf09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-4baa-71aa-a60d-719e8be729a5.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and landscaping.",
        "public_id": "01a01115-4baa-71aa-a60d-719e8be729a5",
        "storage_key": "property/6767906449166443/01a01115-4baa-71aa-a60d-719e8be729a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of a modern apartment building's exterior, featuring stylish architecture, private balconies, and well-maintained landscaping. A concrete pathway and bench offer a serene outdoor space.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e82b14f3-39fd-46a2-9b5a-6a29bf30451b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-80df-7520-a3f8-dd0f32d4be68.webp",
      "image_media": {
        "alt_text": "Mail room with package lockers and mailboxes",
        "public_id": "01a01115-80df-7520-a3f8-dd0f32d4be68",
        "storage_key": "property/6767906449166443/01a01115-80df-7520-a3f8-dd0f32d4be68.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure package lockers and mailboxes for resident convenience in the community mail room.",
      "link": "",
      "alt_text": "Mail room with package lockers and mailboxes",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_688a905b-7215-4ead-a97d-1d318884f4de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-88e4-76dc-84f2-f8caed28f8ee.webp",
      "image_media": {
        "alt_text": "Modern U-shaped kitchen with stainless steel appliances and dark wood cabinets at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-88e4-76dc-84f2-f8caed28f8ee",
        "storage_key": "property/6767906449166443/01a01115-88e4-76dc-84f2-f8caed28f8ee.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this sleek, U-shaped kitchen featuring stainless steel appliances, ample cabinet space, and a spacious countertop, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern U-shaped kitchen with stainless steel appliances and dark wood cabinets at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_734668d1-f925-42fe-a29c-ac0e23651ebc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-9df5-728f-853f-011104aa106f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark grey cabinets, and a white quartz island with bar stools.",
        "public_id": "01a01115-9df5-728f-853f-011104aa106f",
        "storage_key": "property/6767906449166443/01a01115-9df5-728f-853f-011104aa106f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish, modern kitchen featuring stainless steel appliances, ample cabinet space, and a spacious island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark grey cabinets, and a white quartz island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e7a631f0-157b-4317-b3ac-1361083d6835",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-6df9-7377-b974-aca361c966b5.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances and island, flowing into a living room with sectional couch and large window at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-6df9-7377-b974-aca361c966b5",
        "storage_key": "property/6767906449166443/01a01115-6df9-7377-b974-aca361c966b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring a sleek kitchen with ample counter space and stainless steel appliances, opening into a well-appointed living area with comfortable seating and natural light.",
      "link": "",
      "alt_text": "Modern apartment kitchen with stainless steel appliances and island, flowing into a living room with sectional couch and large window at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71e83b1c-189b-4d55-8edf-5d18d75bdc92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-a01c-7411-a99d-8a27eab03d13.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, leather armchair, coffee table, and TV at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-a01c-7411-a99d-8a27eab03d13",
        "storage_key": "property/6767906449166443/01a01115-a01c-7411-a99d-8a27eab03d13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed living room, featuring a comfortable sectional sofa, plush armchairs, and a sleek entertainment center.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, leather armchair, coffee table, and TV at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ddb4bdf5-0d42-40e0-adce-7444a5937708",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-c8b3-719b-9836-7198bd431307.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island  at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-c8b3-719b-9836-7198bd431307",
        "storage_key": "property/6767906449166443/01a01115-c8b3-719b-9836-7198bd431307.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, stainless steel appliances, and a large white island, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island  at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60e69f10-8879-4ecb-b3c5-b6e5eac0b59f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-c940-740a-ae73-018ea37b7bda.webp",
      "image_media": {
        "alt_text": "Spacious living room with sectional sofa, coffee table, and bar area.",
        "public_id": "01a01115-c940-740a-ae73-018ea37b7bda",
        "storage_key": "property/6767906449166443/01a01115-c940-740a-ae73-018ea37b7bda.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Relax in this spacious living area, featuring a comfortable sectional sofa, a stylish coffee table, and a convenient bar area for entertaining.",
      "link": "",
      "alt_text": "Spacious living room with sectional sofa, coffee table, and bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2cd05312-7d7a-4e2b-a7bf-3d5d4723d8a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-cbed-75bd-b937-acdb845a8acd.webp",
      "image_media": {
        "alt_text": "Living room with a large sectional sofa, coffee table, and open kitchen area.",
        "public_id": "01a01115-cbed-75bd-b937-acdb845a8acd",
        "storage_key": "property/6767906449166443/01a01115-cbed-75bd-b937-acdb845a8acd.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious living area with modern decor, opening to a fully equipped kitchen with bar seating. Perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a large sectional sofa, coffee table, and open kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c615d2b-c6c4-4e97-8bec-4b5613fb3695",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-f3fc-72ff-91a7-6e33c7b6ed7a.webp",
      "image_media": {
        "alt_text": "A stylish bedroom with a king-size bed, green accent wall, and modern decor at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-f3fc-72ff-91a7-6e33c7b6ed7a",
        "storage_key": "property/6767906449166443/01a01115-f3fc-72ff-91a7-6e33c7b6ed7a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our beautifully appointed bedrooms, designed for ultimate relaxation.",
      "link": "",
      "alt_text": "A stylish bedroom with a king-size bed, green accent wall, and modern decor at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_857b0b0e-058a-49d1-bdfc-954280bb3c83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-e91b-744b-9395-9a30fc9c6722.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity and view into bedroom at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-e91b-744b-9395-9a30fc9c6722",
        "storage_key": "property/6767906449166443/01a01115-e91b-744b-9395-9a30fc9c6722.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our modern bathrooms, featuring a spacious double vanity and elegant finishes. Step into the adjoining bedroom for a complete view of your tranquil living space.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity and view into bedroom at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a86d7a1c-7788-46b8-81d2-8bce008cecef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-eaa9-7093-9e24-e625952d0fd3.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, nightstand, and shelving unit.",
        "public_id": "01a01115-eaa9-7093-9e24-e625952d0fd3",
        "storage_key": "property/6767906449166443/01a01115-eaa9-7093-9e24-e625952d0fd3.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Inviting bedroom featuring a comfortable queen-size bed, stylish nightstand with lamp, and a wooden shelving unit with decorative plants.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, nightstand, and shelving unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c168fdd-b44f-4d6d-a97a-d702f39ab8b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-e25e-76ef-a0c1-7f62c0e7ba62.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark wood vanity, white countertop, large mirror, and a bathtub with shower.",
        "public_id": "01a01115-e25e-76ef-a0c1-7f62c0e7ba62",
        "storage_key": "property/6767906449166443/01a01115-e25e-76ef-a0c1-7f62c0e7ba62.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Refresh and rejuvenate in this elegant bathroom, featuring a spacious vanity and a pristine bathtub/shower combo.",
      "link": "",
      "alt_text": "Modern bathroom with dark wood vanity, white countertop, large mirror, and a bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d2cc9573-b82d-48c8-bf7b-fe8881182daa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-c7a6-7464-928e-6741248179d0.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, bedside tables, a ceiling fan, and a large window with blinds at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-c7a6-7464-928e-6741248179d0",
        "storage_key": "property/6767906449166443/01a01115-c7a6-7464-928e-6741248179d0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Relax in the spacious and well-appointed bedroom, featuring a comfortable king-size bed and ample natural light from the large window.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, bedside tables, a ceiling fan, and a large window with blinds at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45989772-75a0-4359-b145-c2c5d2c99873",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-a416-76d0-89c1-606b463e3452.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and double vanity.",
        "public_id": "01a01115-a416-76d0-89c1-606b463e3452",
        "storage_key": "property/6767906449166443/01a01115-a416-76d0-89c1-606b463e3452.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our modern bathrooms, featuring a deep soaking tub, elegant vanity, and sleek fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and double vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12be12da-07f7-4403-b878-43a82e452514",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-b2db-75af-8d78-5f6aba3a717c.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with dark wood cabinets, white countertop, large mirror, and contemporary lighting. A toilet is to the left, and a bedroom is visible through an open doorway at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-b2db-75af-8d78-5f6aba3a717c",
        "storage_key": "property/6767906449166443/01a01115-b2db-75af-8d78-5f6aba3a717c.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with ample storage, a sleek countertop, and modern fixtures. This bathroom offers a luxurious and functional space within the apartment.",
      "link": "",
      "alt_text": "Modern bathroom vanity with dark wood cabinets, white countertop, large mirror, and contemporary lighting. A toilet is to the left, and a bedroom is visible through an open doorway at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89f60cb3-fa41-47ac-8646-87d28f5f2127",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-af26-72c5-9f91-9988525c7a1b.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, navy and white bedding, nightstand, and large window with white curtains at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-af26-72c5-9f91-9988525c7a1b",
        "storage_key": "property/6767906449166443/01a01115-af26-72c5-9f91-9988525c7a1b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-size bed, stylish navy and white bedding, and a bedside table with a lamp.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, navy and white bedding, nightstand, and large window with white curtains at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4975b509-be7f-46ee-945f-a7271dd3ad7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-a952-77fd-9f78-0e135dbf3e95.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub  at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-a952-77fd-9f78-0e135dbf3e95",
        "storage_key": "property/6767906449166443/01a01115-a952-77fd-9f78-0e135dbf3e95.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with ample counter space, a comfortable toilet, and a clean, white bathtub/shower combo.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub  at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a4528b48-0454-4f1e-9482-a7079983b846",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/01a01115-bd1c-708e-8f17-0e858928601b.webp",
      "image_media": {
        "alt_text": "A small balcony with a round table and two chairs, decorated with potted plants and a grey door at Parc South Mountain in Phoenix, AZ.",
        "public_id": "01a01115-bd1c-708e-8f17-0e858928601b",
        "storage_key": "property/6767906449166443/01a01115-bd1c-708e-8f17-0e858928601b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or an evening drink on this private balcony, complete with a table, chairs, and lush greenery.",
      "link": "",
      "alt_text": "A small balcony with a round table and two chairs, decorated with potted plants and a grey door at Parc South Mountain in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_63f5d8ea-c157-45fe-a3ef-927239e12546",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "The Gaming Zone",
      "poi_type": "Entertainment",
      "poi_address": "930 W Broadway Rd #5, Tempe, AZ 85282, USA",
      "poi_short_description": "Outlet that buys & sells video games, hosts tournaments & has a lounge with over a dozen TVs.",
      "poi_long_description": "People say this video arcade offers a wide variety of games and a fun arcade area. They highlight the reasonable prices and the helpful and supportive staff. They also like the friendly service and the genuine passion for games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-535b-7749-8940-8341c6387570.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-535b-7749-8940-8341c6387570",
        "storage_key": "property/6767906449166443/019d02cc-535b-7749-8940-8341c6387570.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://thegamingzone.bigcartel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13264242932906904730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-gaming-zone",
      "poi_latitude": "33.4077427",
      "poi_longitude": "-111.9534315",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-245-6357",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk4S8U8sIK4cRmsxmpqsOFLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_00337020-616a-4809-a901-c4c4d3b97b85",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Harkins Theatres Arizona Mills w/IMAX",
      "poi_type": "Entertainment",
      "poi_address": "ARIZONA MILLS, 5000 S Arizona Mills Cir, Tempe, AZ 85282, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "People say this movie theater offers a great IMAX experience with a large screen and excellent sound quality. They highlight the comfortable, reclining seats and the convenient location with ample parking. They also like the friendly staff and the clean, modern facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-54d9-71bf-85f7-69693f766808.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-54d9-71bf-85f7-69693f766808",
        "storage_key": "property/6767906449166443/019d02cc-54d9-71bf-85f7-69693f766808.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://harkins.com/theatres/arizona-mills-w-imax/?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4473862646923159364&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harkins-theatres-arizona-mills-wimax",
      "poi_latitude": "33.3853645",
      "poi_longitude": "-111.9658986",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-820-0387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-77b4-72ad-b888-72f6b4bc852b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-77b4-72ad-b888-72f6b4bc852b",
        "storage_key": "property/6767906449166443/019d02cc-77b4-72ad-b888-72f6b4bc852b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3vqPlQIK4cRRGe-s19aFj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_79102063-d277-4eac-98bc-926736c9248b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "K1 Speed Phoenix",
      "poi_type": "Entertainment",
      "poi_address": "2501 E Magnolia St, Phoenix, AZ 85034, USA",
      "poi_short_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_long_description": "People say this amusement center offers fast go-karts, a fun track, and an arcade with games. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the thrilling atmosphere.\n\nSome reviews mention the games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-53a4-75f8-9195-900f4b891d11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-53a4-75f8-9195-900f4b891d11",
        "storage_key": "property/6767906449166443/019d02cc-53a4-75f8-9195-900f4b891d11.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://k1speed.com/phoenix-location.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16366161456476043528&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "k1-speed-phoenix",
      "poi_latitude": "33.4218087",
      "poi_longitude": "-112.0284479",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-275-5278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVamTvTwOK4cRCLnxDSJJIOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_09f6e816-104f-46ba-a6f6-2ccb576c2342",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "SEA LIFE Arizona Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "5000 S Arizona Mills Cir Suite 145, Tempe, AZ 85282, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "People say this aquarium offers a variety of sea life, including sharks, sea turtles, and stingrays, and features a tunnel and touch tanks. They highlight the affordable cost and kid-friendly atmosphere, with a play area and exhibits at child-friendly heights. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-5311-771e-8547-7aac6b22bb68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-5311-771e-8547-7aac6b22bb68",
        "storage_key": "property/6767906449166443/019d02cc-5311-771e-8547-7aac6b22bb68.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.visitsealife.com/arizona/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=5764640459261859178&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sea-life-arizona-aquarium",
      "poi_latitude": "33.38481",
      "poi_longitude": "-111.9633344",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-565-7072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Qh3DFoPK4cRatUlkPQdAFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_967b6242-9d85-4a31-b6be-aa4d960b59a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "LEGOLAND® Discovery Center Arizona",
      "poi_type": "Entertainment",
      "poi_address": "5000 S Arizona Mills Cir STE 135, Tempe, AZ 85282, USA",
      "poi_short_description": "Upbeat amusement center featuring family-friendly exhibits, 4D movies, rides & a Lego factory tour.",
      "poi_long_description": "People say this children's amusement center offers fun rides, games, and Lego building stations. They also highlight the clean, well-organized environment, and the friendly, helpful staff.\n\nSome reviews mention there can be limited activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-57d4-709a-aed8-7259fe50b35f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-57d4-709a-aed8-7259fe50b35f",
        "storage_key": "property/6767906449166443/019d02cc-57d4-709a-aed8-7259fe50b35f.webp",
        "width": 600,
        "height": 411
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/arizona/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=9103573918068574278&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "legoland-discovery-center-arizona",
      "poi_latitude": "33.3856183",
      "poi_longitude": "-111.9634524",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-565-7072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzRgr5FkPK4cRRgj95D5kVn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_1c99b340-7f25-43be-a465-28d8207eec48",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "dd's DISCOUNTS",
      "poi_type": "Shopping & Retail",
      "poi_address": "2030 E Baseline Rd, Phoenix, AZ 85042, USA",
      "poi_short_description": "Retail chain stocking discounted clothing & shoes for adults or kids, plus home decor.",
      "poi_long_description": "People say this clothing store offers fashionable clothing trends. They highlight the excellent prices and discounts. They also like the accessible prices for new and up-to-date merchandise.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-5850-74b3-8d57-588a86b22f17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-5850-74b3-8d57-588a86b22f17",
        "storage_key": "property/6767906449166443/019d02cc-5850-74b3-8d57-588a86b22f17.webp",
        "width": 1196,
        "height": 673
      },
      "poi_business_url": "https://www.ddsdiscounts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11264580988548581729&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dds-discounts",
      "poi_latitude": "33.3795871",
      "poi_longitude": "-112.0366458",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-268-3729",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e8-71cb-9e2e-ecf02252d00a",
        "storage_key": "property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU8VinQMPK4cRYYkODrrUU5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e71b536e-8648-42c8-b91e-fe9ce345538f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "2040 E Baseline Rd, Phoenix, AZ 85042, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a good selection of items and great deals on clothes and home items. They also highlight the good value for your money and the exciting and different shopping experience.\n\nSome reviews mention the store hours can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-582f-73df-87a7-11341c0f15c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-582f-73df-87a7-11341c0f15c5",
        "storage_key": "property/6767906449166443/019d02cc-582f-73df-87a7-11341c0f15c5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=666702654684108520&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "33.37959540000001",
      "poi_longitude": "-112.036166",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-268-8798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e8-71cb-9e2e-ecf02252d00a",
        "storage_key": "property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfSA5A-UPK4cR6JZBN4iaQAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_f62b7f02-3944-4151-bf52-b1437227e245",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Phoenix Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "4976 Premium Outlets Way, Chandler, AZ 85226, USA",
      "poi_short_description": "Casual, outdoor retailer featuring more than 90 outlet stores for brands like Adidas, Nike, and Coach.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores and a good selection of products. They highlight the reasonable prices and the family-friendly, clean, and casual vibe. They also like the easy parking and the availability of shaded areas and water features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-59d8-729d-9346-2d5fbd1e399d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-59d8-729d-9346-2d5fbd1e399d",
        "storage_key": "property/6767906449166443/019d02cc-59d8-729d-9346-2d5fbd1e399d.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/phoenix",
      "poi_directions_map_url": "https://maps.google.com/?cid=389775038611643144&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "phoenix-premium-outlets",
      "poi_latitude": "33.287704",
      "poi_longitude": "-111.9734187",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-639-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e8-71cb-9e2e-ecf02252d00a",
        "storage_key": "property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhZhPivQDK4cRCNvCHlXCaAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b0b0bd3f-d935-4a62-8b47-1fd52beb6085",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6150 S 35th Ave, Phoenix, AZ 85041, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this hypermarket offers a wide array of items and affordable prices.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-5d68-713f-b0bc-413702454c9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-5d68-713f-b0bc-413702454c9f",
        "storage_key": "property/6767906449166443/019d02cc-5d68-713f-b0bc-413702454c9f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3771-phoenix-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10158298521244669802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.3904631",
      "poi_longitude": "-112.1366875",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-243-8506",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4eb-721b-8072-0aa0bc5468d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4eb-721b-8072-0aa0bc5468d2",
        "storage_key": "property/6767906449166443/019d02ca-e4eb-721b-8072-0aa0bc5468d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJORGw7SkRK4cRahcqIa-G-Yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hypermarket"
    },
    {
      "id": "custom_b060ea07-0a48-46af-b483-cdf10f9c5aa4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2140 E Baseline Rd, Phoenix, AZ 85042, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of items. They also highlight the decent prices and easy-to-find products.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-5d66-75fe-bffd-93fc91690b88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-5d66-75fe-bffd-93fc91690b88",
        "storage_key": "property/6767906449166443/019d02cc-5d66-75fe-bffd-93fc91690b88.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/south-mountain/1905",
      "poi_directions_map_url": "https://maps.google.com/?cid=15350611473934153946&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.3793622",
      "poi_longitude": "-112.0347245",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-281-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e8-71cb-9e2e-ecf02252d00a",
        "storage_key": "property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDcZ2n-8PK4cR2njh9M1TCNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_10e978e8-9b2d-4ca2-9c2d-aef6f80dadb0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Paris Baguette",
      "poi_type": "Restaurants",
      "poi_address": "3230 E Baseline Rd Suite A-130, Phoenix, AZ 85042, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this bakery offers delicious pastries, cakes, and sweets, including baguettes, croissants, and seafood puffs. They also highlight the friendly and welcoming staff, and the clean and beautiful atmosphere.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-5fd2-7092-9141-036103a11895.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-5fd2-7092-9141-036103a11895",
        "storage_key": "property/6767906449166443/019d02cc-5fd2-7092-9141-036103a11895.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.parisbaguette.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12836739733505724725&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "paris-baguette",
      "poi_latitude": "33.3788465",
      "poi_longitude": "-112.0105937",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-674-4476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e9-72cb-874d-a2ccc17d64ec",
        "storage_key": "property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7qMBpgPK4cRNVHAkcZCJbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_534cf568-58e3-4ef8-826a-9c32376f5976",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Princess Pita Mediterranean Restaurant -South Phoenix",
      "poi_type": "Restaurants",
      "poi_address": "2170 E Baseline Rd, Phoenix, AZ 85042, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this restaurant serves delicious gyros, shawarma, and lamb chops. They highlight the fresh, flavorful, and authentic Mediterranean and Arabic food, and the generous portions. They also like the friendly and efficient service, and the clean and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-5e58-7119-9a2f-d28d73c58796.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-5e58-7119-9a2f-d28d73c58796",
        "storage_key": "property/6767906449166443/019d02cc-5e58-7119-9a2f-d28d73c58796.webp",
        "width": 811,
        "height": 608
      },
      "poi_business_url": "https://princesspitaaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1029864230297106588&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "princess-pita-mediterranean-restaurant--south-phoenix",
      "poi_latitude": "33.3793599",
      "poi_longitude": "-112.0325784",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-996-3849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e9-72cb-874d-a2ccc17d64ec",
        "storage_key": "property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJanCek8PK4cRnHi9nQ_QSg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fe50a2ba-0bb3-4786-a2f2-933e0685b460",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Xami Sushi",
      "poi_type": "Restaurants",
      "poi_address": "2707 E Broadway Rd, Phoenix, AZ 85040, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this sushi restaurant serves delicious assorted nigiri, baked salmon rolls, and other dishes. They highlight the great value, fresh ingredients, and authentic flavors. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-62e8-74c8-956c-f56821657d54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-62e8-74c8-956c-f56821657d54",
        "storage_key": "property/6767906449166443/019d02cc-62e8-74c8-956c-f56821657d54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://xamisushiaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=860910316196825187&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "xami-sushi",
      "poi_latitude": "33.4066785",
      "poi_longitude": "-112.0236739",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-590-1757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e9-72cb-874d-a2ccc17d64ec",
        "storage_key": "property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ51FHagAPK4cRY4hhDF-R8gs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_605bb6e3-5bc9-49fe-a1c6-8f5485031b37",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Gallagher's Sports Grill",
      "poi_type": "Restaurants",
      "poi_address": "3220 E Baseline Rd #100, Phoenix, AZ 85042, USA",
      "poi_short_description": "Sports pub for game-watching, off-track betting & karaoke, plus a hearty menu of ribs & burgers.",
      "poi_long_description": "People say this sports bar offers tasty wings, burgers, and onion rings, and has plenty of TVs for watching sports.\n\nOther reviews mention the service can be slow and the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-61f1-735d-be5c-bb553657c0f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-61f1-735d-be5c-bb553657c0f0",
        "storage_key": "property/6767906449166443/019d02cc-61f1-735d-be5c-bb553657c0f0.webp",
        "width": 1136,
        "height": 537
      },
      "poi_business_url": "https://gallaghersaz.com/locations-phoenix-baseline/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2758879547006343750&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gallaghers-sports-grill",
      "poi_latitude": "33.3789137",
      "poi_longitude": "-112.0115",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-437-0981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-7916-759c-9b6a-6412dfa5b370.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-7916-759c-9b6a-6412dfa5b370",
        "storage_key": "property/6767906449166443/019d02cc-7916-759c-9b6a-6412dfa5b370.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJESt1cIUPK4cRRlpnsVSCSSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_3abbe04b-afdf-494c-8ab5-91114ee16fcf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "JL Smokehouse BBQ",
      "poi_type": "Restaurants",
      "poi_address": "2010 E Broadway Rd, Phoenix, AZ 85040, USA",
      "poi_short_description": "Sausage, brisket & other southern barbecue staples in a down-home destination with a rustic vibe.",
      "poi_long_description": "People say this barbecue restaurant serves delicious smoked meats, including brisket, ribs, and pulled pork, as well as tasty sides like mac and cheese, collard greens, and potato salad. They highlight the generous portions, reasonable prices, and the friendly, upbeat staff. They also like the enjoyable dining experience with good music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-6400-771c-ad63-119000d44b01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-6400-771c-ad63-119000d44b01",
        "storage_key": "property/6767906449166443/019d02cc-6400-771c-ad63-119000d44b01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jlsmokehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7371668379099868897&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jl-smokehouse-bbq",
      "poi_latitude": "33.4070918",
      "poi_longitude": "-112.0379866",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-620-5132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e9-72cb-874d-a2ccc17d64ec",
        "storage_key": "property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQ-XLCsOK4cR4S46glVtTWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_183f7ea5-718a-46e2-b090-94b6cb38f75c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "The Farm Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "6106 S 32nd St, Phoenix, AZ 85042, USA",
      "poi_short_description": "Laid-back spot serving baked goods, salads and sandwiches, plus picnic-style options.",
      "poi_long_description": "People say this lunch restaurant offers delicious sandwiches, salads, and farm-to-table options, with some mentioning the avocado egg salad sandwich and Snickers cake as highlights. They highlight the beautiful, peaceful, and pet-friendly outdoor dining experience, with opportunities to explore the farm and gardens. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-67cf-741c-9773-bae82aa3a744.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-67cf-741c-9773-bae82aa3a744",
        "storage_key": "property/6767906449166443/019d02cc-67cf-741c-9773-bae82aa3a744.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thefarmatsouthmountain.com/the-farm-kitchen/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15728149308286788312&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-farm-kitchen",
      "poi_latitude": "33.3910335",
      "poi_longitude": "-112.012925",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-276-6545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e9-72cb-874d-a2ccc17d64ec",
        "storage_key": "property/6767906449166443/019d02ca-e4e9-72cb-874d-a2ccc17d64ec.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3EE5JcPK4cR2GK97nacRdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5ba9232d-8db5-40fd-8a79-6c9aaa086ffb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Arizona Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 S Arizona Mills Cir, Tempe, AZ 85282, USA",
      "poi_short_description": "Lively mall featuring an aquarium, a cinema, a food court, a Lego center and many big-box stores.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including outlets, and attractions like an aquarium, arcade, and movie theater. They also highlight the good deals, spacious layout, and family-friendly atmosphere with a carousel and train ride.\n\nOther reviews mention the food court can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-a7ca-72c0-bb40-744fda606ab8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a7ca-72c0-bb40-744fda606ab8",
        "storage_key": "property/6767906449166443/019d02ca-a7ca-72c0-bb40-744fda606ab8.webp",
        "width": 700,
        "height": 467
      },
      "poi_business_url": "https://www.simon.com/mall/arizona-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=2145774981481083229&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-mills",
      "poi_latitude": "33.383125",
      "poi_longitude": "-111.964485",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-491-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4e8-71cb-9e2e-ecf02252d00a",
        "storage_key": "property/6767906449166443/019d02ca-e4e8-71cb-9e2e-ecf02252d00a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh_lm4VkPK4cRXbEZE_pSxx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_eb819305-da43-423a-8783-a048b4f19d6c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Tempe Public Library",
      "poi_type": "Education",
      "poi_address": "3500 S Rural Rd, Tempe, AZ 85282, USA",
      "poi_short_description": "Public library offering books and media for checkout, plus a cafe and programs.",
      "poi_long_description": "People say this public library offers a wide selection of literature. They highlight the open and friendly vibe. They also like the helpful and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-b404-716f-a39c-e76edaf28fba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-b404-716f-a39c-e76edaf28fba",
        "storage_key": "property/6767906449166443/019d02ca-b404-716f-a39c-e76edaf28fba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tempepubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13306252390981778904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tempe-public-library",
      "poi_latitude": "33.39131450000001",
      "poi_longitude": "-111.9280626",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-350-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4ef-771a-8612-f7f55f003baf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4ef-771a-8612-f7f55f003baf",
        "storage_key": "property/6767906449166443/019d02ca-e4ef-771a-8612-f7f55f003baf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR35tTZ8IK4cR2D0p0AxOqbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_90f40b15-ea32-4d02-a6bc-05d25aaf2c5b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "750 E Guadalupe Rd, Tempe, AZ 85283, USA",
      "poi_short_description": "Gym featuring an extensive selection of workout machines and free weights, plus cold plunge.",
      "poi_long_description": "People say this gym offers a wide variety of modern equipment, including a cold plunge and hot tub, and has a large, open space. They highlight the affordable price and motivating, vibrant atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-be1f-7210-aa81-ea7468d0a0e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-be1f-7210-aa81-ea7468d0a0e6",
        "storage_key": "property/6767906449166443/019d02ca-be1f-7210-aa81-ea7468d0a0e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.eosfitness.com/gym/tempe-s-rural-rd-e-guadalupe-rd?utm_source=local&utm_medium=organic&utm_content=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9308301848450095421&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.3650342",
      "poi_longitude": "-111.9300785",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 480-602-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSuaJM0HK4cRPdn6sja7LYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c9b25719-99eb-4a9a-8d8e-9817cd89db1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "The Salvation Army Ray and Joan Kroc Center Phoenix",
      "poi_type": "Health and Wellness",
      "poi_address": "1375 E Broadway Rd, Phoenix, AZ 85040, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of activities, including an indoor pool with a slide and rock wall, an outdoor splash pad, a library, and an arts and crafts area. They highlight the facility is clean and well-maintained, and the pool is fun for kids of all ages. They also like the friendly and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-bf12-735d-98da-20ad36542c47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-bf12-735d-98da-20ad36542c47",
        "storage_key": "property/6767906449166443/019d02ca-bf12-735d-98da-20ad36542c47.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://krocphoenix.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2310703491351060323&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-salvation-army-ray-and-joan-kroc-center-phoenix",
      "poi_latitude": "33.4062036",
      "poi_longitude": "-112.0527603",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtdpI6tQRK4cRYx88L5VEESA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eab59631-a737-4601-a832-2b354e8f5d1b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1616 W Ruby Dr, Tempe, AZ 85284, USA",
      "poi_short_description": "Family-friendly athletic club offering a fitness floor, studio classes, indoor and outdoor pools, plus a spa and kids’ programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-c06e-7588-9972-ce622aef0406.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-c06e-7588-9972-ce622aef0406",
        "storage_key": "property/6767906449166443/019d02ca-c06e-7588-9972-ce622aef0406.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lifetime.life/locations/az/tempe.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=2681829493569576902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "33.3413432",
      "poi_longitude": "-111.9643591",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-705-8855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB99P-80FK4cRxl9hKLfFNyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ec408e0c-0cd8-4a45-8034-99c29a3513b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Mountainside Fitness Tempe Marina Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "300 E Rio Salado Pkwy #102, Tempe, AZ 85281, USA",
      "poi_short_description": "Chain, featuring state-of-the-art exercise equipment, plus views of Tempe Town Lake and the Salt River.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-c0eb-7144-b532-607512213705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-c0eb-7144-b532-607512213705",
        "storage_key": "property/6767906449166443/019d02ca-c0eb-7144-b532-607512213705.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/tempe-marina-heights/?utm_source=GMB&utm_medium=Local&utm_campaign=Tempe&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=9270648553778270050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-tempe-marina-heights",
      "poi_latitude": "33.4310649",
      "poi_longitude": "-111.9336089",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 480-664-6209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3Re0SYJK4cRYk9x3b31p4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3f0b00b9-b010-4e14-a770-0506a6dd953a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3975 E Thomas Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Gym featuring equipment for workouts and showers.",
      "poi_long_description": "Visitors say this gym is clean and well-maintained with a wide variety of equipment, including treadmills, ellipticals, and strength training machines. They also highlight the friendly and helpful staff, and the great value for the price.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-c395-70e7-973b-7d86dc66b8ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-c395-70e7-973b-7d86dc66b8ba",
        "storage_key": "property/6767906449166443/019d02ca-c395-70e7-973b-7d86dc66b8ba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/phoenix-arcadia-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10081781952939074657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.4784244",
      "poi_longitude": "-111.9964886",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-275-0681",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVS_XNLUNK4cRYaTgR0Wv6Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_11d06252-cf32-4234-bab9-db86c37575cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "63 E Southern Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "Clean gym offering classes, weights and cardiovascular equipment.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, free weights, and a basketball court, as well as amenities like a pool and sauna. They also highlight the spacious layout, clean facilities, and friendly, helpful staff.\n\nOther reviews mention the gym can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-c3ef-70c5-9a2f-8a43caddc859.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-c3ef-70c5-9a2f-8a43caddc859",
        "storage_key": "property/6767906449166443/019d02ca-c3ef-70c5-9a2f-8a43caddc859.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=38&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14282970337445433486&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.3916509",
      "poi_longitude": "-111.9381288",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-829-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdgTFaUIK4cRjlDg9NhNN8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e0c1d053-d2a6-4dd1-8ed5-dd3820db24d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Ability360 Sports & Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5031 E Washington St, Phoenix, AZ 85034, USA",
      "poi_short_description": "Large state-of-the-art & accessible fitness center with pools, spa, gym, basketball courts & track.",
      "poi_long_description": "People say this gym offers amazing facilities with accommodations for all ability levels. They highlight the facilities are well-maintained and beautiful. They also like the rock wall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-c622-730c-85ff-a0bbd2d9b713.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-c622-730c-85ff-a0bbd2d9b713",
        "storage_key": "property/6767906449166443/019d02ca-c622-730c-85ff-a0bbd2d9b713.webp",
        "width": 1280,
        "height": 734
      },
      "poi_business_url": "https://ability360.org/sports",
      "poi_directions_map_url": "https://maps.google.com/?cid=74284183542707757&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ability360-sports--fitness-center",
      "poi_latitude": "33.4451355",
      "poi_longitude": "-111.9737363",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-386-4566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzcFXb4OK4cRLTZ-RBLpBwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e12e9eae-58a6-4cd6-bba8-e70811e4728b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Banner - University Medical Center Phoenix",
      "poi_type": "Health and Wellness",
      "poi_address": "1111 E McDowell Rd, Phoenix, AZ 85006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-c662-750f-af2d-41d7346fedc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-c662-750f-af2d-41d7346fedc4",
        "storage_key": "property/6767906449166443/019d02ca-c662-750f-af2d-41d7346fedc4.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/phoenix/banner-university-medical-center-phoenix?y_source=1_MTE5MDczNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=5784332207521473033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner---university-medical-center-phoenix",
      "poi_latitude": "33.4645644",
      "poi_longitude": "-112.0573664",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-839-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f66e-74c8-ade7-33b593d28203.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f66e-74c8-ade7-33b593d28203",
        "storage_key": "property/6767906449166443/019d02ca-f66e-74c8-ade7-33b593d28203.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoV6LoQ0SK4cRCSIr_H4TRlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_778b7a85-2962-454d-9b79-69f307da817e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Phoenix Children's Hospital - Thomas Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "1919 E Thomas Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-c9dd-720e-8ad1-4875df3ef29e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-c9dd-720e-8ad1-4875df3ef29e",
        "storage_key": "property/6767906449166443/019d02ca-c9dd-720e-8ad1-4875df3ef29e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://phoenixchildrens.org/locations/Phoenix/1919-E-Thomas-Rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=6808680874366999376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-childrens-hospital---thomas-campus",
      "poi_latitude": "33.4792497",
      "poi_longitude": "-112.0419475",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-933-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f66e-74c8-ade7-33b593d28203.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f66e-74c8-ade7-33b593d28203",
        "storage_key": "property/6767906449166443/019d02ca-f66e-74c8-ade7-33b593d28203.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJeVRSn_8NK4cRUBukaS5LfV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e4ebe0bd-9cd9-4a06-80c3-c9922588a744",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Desert Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Botanical garden plus butterfly area featuring red-rock hiking paths and exhibitions of art.",
      "poi_long_description": "People say this botanical garden offers a beautiful desert landscape with a wide variety of cacti, succulents, and desert plants, as well as a butterfly garden and a pond. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails and water fountains. They also like the friendly and informative docents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-ca42-74d8-9630-c3b2be288004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-ca42-74d8-9630-c3b2be288004",
        "storage_key": "property/6767906449166443/019d02ca-ca42-74d8-9630-c3b2be288004.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dbg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2404053162249248023&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-botanical-garden",
      "poi_latitude": "33.4616795",
      "poi_longitude": "-111.944926",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 480-941-1225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f666-76ff-afc0-cbb9e54037e2",
        "storage_key": "property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ4tCFMJK4cRF10FJZ3pXCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_1d61c1c0-6f52-426e-82cf-0a5a26f572b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Papago Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Scenic park (and recreation area) featuring hiking trails, a zoo, a botanical garden and picnic areas.",
      "poi_long_description": "People say this park offers scenic trails, unique rock formations, and the iconic Hole-in-the-Rock, perfect for hiking, running, and photography. They highlight the peaceful and natural vibe, with opportunities for picnics, fishing, and enjoying the sunset. They also like the easy access, convenient parking, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-cd92-749d-a7ad-5d8ad7698d33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-cd92-749d-a7ad-5d8ad7698d33",
        "storage_key": "property/6767906449166443/019d02ca-cd92-749d-a7ad-5d8ad7698d33.webp",
        "width": 1280,
        "height": 747
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/papago-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13874092191196013735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "papago-park",
      "poi_latitude": "33.4536315",
      "poi_longitude": "-111.948693",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f666-76ff-afc0-cbb9e54037e2",
        "storage_key": "property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4MLk0wJK4cRp2RC_VatisA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f7b78835-6fc3-4f72-a183-d0f622063a09",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Hole in the Rock",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Rock formation with scenic views is also a historical landmark and features picnic areas.",
      "poi_long_description": "People say this hiking area offers a short, easy climb with beautiful views of the city, desert landscape, and a unique rock formation with a hole. They highlight the scenic photo opportunities, the relaxing atmosphere, and the opportunity to watch the sunrise or sunset. They also like the easy access, free parking, and nearby amenities such as picnic tables and restrooms. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-ce2c-7199-92ea-1d023dfaf2fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-ce2c-7199-92ea-1d023dfaf2fd",
        "storage_key": "property/6767906449166443/019d02ca-ce2c-7199-92ea-1d023dfaf2fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/papago-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=385298564104506413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hole-in-the-rock",
      "poi_latitude": "33.4564869",
      "poi_longitude": "-111.9452606",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f666-76ff-afc0-cbb9e54037e2",
        "storage_key": "property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWuhyFEJK4cRLczqrQDbWAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_0ecad17f-7496-42e6-ba80-8c977fa7aa84",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Japanese Friendship Garden of Phoenix",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1125 N 3rd Ave, Phoenix, AZ 85003, USA",
      "poi_short_description": "Traditional Japanese strolling garden with a gift shop, monthly tea ceremonies, and workshops.",
      "poi_long_description": "People say this garden offers a peaceful escape with beautiful water features, koi ponds, and lush greenery. They highlight the serene and tranquil atmosphere, perfect for relaxation and meditation. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-cf60-71bb-93ed-722c2b73f0ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-cf60-71bb-93ed-722c2b73f0ab",
        "storage_key": "property/6767906449166443/019d02ca-cf60-71bb-93ed-722c2b73f0ab.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.japanesefriendshipgarden.org/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=1646036250481864746",
      "poi_directions_map_url": "https://maps.google.com/?cid=17408193586874965605&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "japanese-friendship-garden-of-phoenix",
      "poi_latitude": "33.4609597",
      "poi_longitude": "-112.0765703",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-274-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f666-76ff-afc0-cbb9e54037e2",
        "storage_key": "property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5CSNjkSK4cRZV7qrtVTlvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_b5a57482-3e30-40a4-a01b-3046a2a2306f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "South Mountain Park and Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10919 S Central Ave, Phoenix, AZ 85042, USA",
      "poi_short_description": "Vast park with desert scenery and mountain trails for hiking, biking, and horseback riding amid wildlife.",
      "poi_long_description": "People say this park offers hiking trails with stunning views of the valley, especially at sunset. They highlight the trails are suitable for various skill levels, from easy to challenging, and the park is spacious enough to avoid crowds. They also like the accessible views from Dobbins Point, which can be reached by car. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-d0fb-73fe-8950-9101828839c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-d0fb-73fe-8950-9101828839c3",
        "storage_key": "property/6767906449166443/019d02ca-d0fb-73fe-8950-9101828839c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/administration/departments/parks/activities-facilities/trails/south-mountain-parkpreserve.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7241350686142470773&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-mountain-park-and-preserve",
      "poi_latitude": "33.3403368",
      "poi_longitude": "-112.0609473",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f666-76ff-afc0-cbb9e54037e2",
        "storage_key": "property/6767906449166443/019d02ca-f666-76ff-afc0-cbb9e54037e2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfybkSL8aK4cRdZqNLRVyfmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ca367b5d-4b4b-4850-8267-b5540bf0ddfd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Phoenix Sky Harbor International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3400 Sky Hbr Blvd, Phoenix, AZ 85034, USA",
      "poi_short_description": "This 3,000-acre airport serving the Phoenix area  features rail service & a variety of artwork.",
      "poi_long_description": "People say this airport offers a convenient sky train connecting terminals and the rental car center, and has a modern design with moving walkways. They also highlight the friendly staff, clean bathrooms, and easy navigation.\n\nOther reviews mention the airport can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-d340-733c-ae60-1090c158f0d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-d340-733c-ae60-1090c158f0d1",
        "storage_key": "property/6767906449166443/019d02ca-d340-733c-ae60-1090c158f0d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyharbor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436507786966396482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-sky-harbor-international-airport",
      "poi_latitude": "33.435249",
      "poi_longitude": "-112.010124",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-273-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f6a4-71c0-afe9-9e0c5845904d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f6a4-71c0-afe9-9e0c5845904d",
        "storage_key": "property/6767906449166443/019d02ca-f6a4-71c0-afe9-9e0c5845904d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXADM1wOK4cRQu5W4tU19YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_466ee03e-0234-400c-b71b-325943561be0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Terminal 3 Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "3251 Sky Hbr Blvd, Phoenix, AZ 85034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-d438-7729-9e92-9d267e0fbbc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-d438-7729-9e92-9d267e0fbbc1",
        "storage_key": "property/6767906449166443/019d02ca-d438-7729-9e92-9d267e0fbbc1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyharbor.com/PHXSkyTrain",
      "poi_directions_map_url": "https://maps.google.com/?cid=9219709577021401694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "terminal-3-station",
      "poi_latitude": "33.43473",
      "poi_longitude": "-112.00998",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-273-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7F5jGcOK4cRXqqgHgP98n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_1dec508e-ecef-4d2a-92b3-8c37cf75acfb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "44th St/Washington",
      "poi_type": "Transportation & Transit",
      "poi_address": "4299, 4399 E Washington St, Phoenix, AZ 85008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-d571-748e-b19d-dd6fc4803e51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-d571-748e-b19d-dd6fc4803e51",
        "storage_key": "property/6767906449166443/019d02ca-d571-748e-b19d-dd6fc4803e51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valleymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3393582418176576930&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "44th-stwashington",
      "poi_latitude": "33.4481899",
      "poi_longitude": "-111.9879484",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-251-2039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuS015I8OK4cRog1ttzptGC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_857a6f2f-828f-4875-ad12-9fca42f3c170",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "44th St Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-d761-7468-82f9-32bfb544e607.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-d761-7468-82f9-32bfb544e607",
        "storage_key": "property/6767906449166443/019d02ca-d761-7468-82f9-32bfb544e607.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.skyharbor.com/PHXSkyTrain",
      "poi_directions_map_url": "https://maps.google.com/?cid=13752464089485512657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "44th-st-station",
      "poi_latitude": "33.4469408",
      "poi_longitude": "-111.990366",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNaqyu48OK4cR0Y8ZyDmR2r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_14b69ec2-4a3e-4e83-9c13-d18b997b68d9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Veterans Way/College Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-d91c-7236-b3d5-e999e3d8cd31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-d91c-7236-b3d5-e999e3d8cd31",
        "storage_key": "property/6767906449166443/019d02ca-d91c-7236-b3d5-e999e3d8cd31.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4598022879801229784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterans-waycollege-ave",
      "poi_latitude": "33.426067",
      "poi_longitude": "-111.935959",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30kcm9gIK4cR2MGro3J1zz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7f6d51f5-4d4e-4ba3-8630-8c60ec361a7b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "State Farm at Marina Heights",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 E Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-d989-70fe-ba68-17df46cdea5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-d989-70fe-ba68-17df46cdea5a",
        "storage_key": "property/6767906449166443/019d02ca-d989-70fe-ba68-17df46cdea5a.webp",
        "width": 1280,
        "height": 1049
      },
      "poi_business_url": "https://www.statefarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1601884207670731235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-farm-at-marina-heights",
      "poi_latitude": "33.4299472",
      "poi_longitude": "-111.9305218",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-733-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_x42CAJK4cR46GFITMJOxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cab78207-09c9-403f-bd27-81004e88442d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Amazon AZA3",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1665 W Alameda Dr #101, Tempe, AZ 85282, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-dba4-7125-a3fc-d152a2c742b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-dba4-7125-a3fc-d152a2c742b9",
        "storage_key": "property/6767906449166443/019d02ca-dba4-7125-a3fc-d152a2c742b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10427779108402156537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-aza3",
      "poi_latitude": "33.3982292",
      "poi_longitude": "-111.9650968",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJa0zIPK4cR-dOMsNnptpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_66fd6515-517a-4e29-8968-09edd0d848aa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Amazon Tempe Software Center PHX11",
      "poi_type": "Major Employers & Offices",
      "poi_address": "40 E Rio Salado Pkwy #600, Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-dd2c-736f-a5b3-211317e0ac33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-dd2c-736f-a5b3-211317e0ac33",
        "storage_key": "property/6767906449166443/019d02ca-dd2c-736f-a5b3-211317e0ac33.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14824221418433897925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-tempe-software-center-phx11",
      "poi_latitude": "33.4302373",
      "poi_longitude": "-111.939487",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-266-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtR3mFyYJK4cRxWV9hdY2us0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cbdfd2e0-dd09-47ca-9d4e-b48b96c1edef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "PHX12 - Amazon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 S Mill Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-df7e-73de-9f96-56fded2c02b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-df7e-73de-9f96-56fded2c02b8",
        "storage_key": "property/6767906449166443/019d02ca-df7e-73de-9f96-56fded2c02b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2197275368270750170&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phx12---amazon",
      "poi_latitude": "33.4291744",
      "poi_longitude": "-111.9406587",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaYTxPgJK4cR2mF-R05Kfh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a2b395ed-b98c-434a-9838-f00727b20dcf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Phoenix City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 W Washington St, Phoenix, AZ 85003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-df76-74c9-910b-198747d41208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-df76-74c9-910b-198747d41208",
        "storage_key": "property/6767906449166443/019d02ca-df76-74c9-910b-198747d41208.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.phoenix.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6171114499780558672&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-city-hall",
      "poi_latitude": "33.4487244",
      "poi_longitude": "-112.0773405",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-262-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f212-71ae-9fbb-50f66f6032d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f212-71ae-9fbb-50f66f6032d2",
        "storage_key": "property/6767906449166443/019d02ca-f212-71ae-9fbb-50f66f6032d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTOCVyESK4cRUL-uC_EzpFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_ab809d3b-8550-4b32-ab56-587f34249093",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Cloves C. Campbell Sr. School",
      "poi_type": "Education",
      "poi_address": "2624 E South Mountain Ave, Phoenix, AZ 85042",
      "poi_short_description": "Zoned Roosevelt ESD K-8 (elementary + middle grades).",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3ebfe822-88a3-4cfa-a96a-9751d3e26cff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "South Mountain High School",
      "poi_type": "Education",
      "poi_address": "5401 S 7th St, Phoenix, AZ 85040",
      "poi_short_description": "Zoned Phoenix Union high school.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "70",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a9ef1c0c-b76e-4b1f-990f-bfc2cd3ce2bf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Mormon Trailhead (South Mountain Park)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8610 S 24th St, Phoenix, AZ 85042",
      "poi_short_description": "Closest South Mountain Park & Preserve access point and trailhead.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "60",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_376f6fec-02a8-4e81-adbc-6a453c3a9057",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Valley Metro Route 61 - Southern Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Southern Ave & 32nd St, Phoenix, AZ 85040",
      "poi_short_description": "Bus route running east-west along Southern Ave by the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8a368593-d67e-4be7-b215-e173ded091c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "The Cotton Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4300 E Cotton Center Blvd, Phoenix, AZ 85040",
      "poi_short_description": "Large employment park (CVS Caremark, UnitedHealthcare, Freeport-McMoRan and more).",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "40",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e6db8e6e-890f-459e-8286-c534a134a96a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "South Mountain Community College",
      "poi_type": "Education",
      "poi_address": "7050 S 24th St, Phoenix, AZ 85042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019f05f8-c255-7064-8381-b35377b641da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f05f8-c255-7064-8381-b35377b641da",
        "storage_key": "property/6767906449166443/019f05f8-c255-7064-8381-b35377b641da.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.southmountaincc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10839400644532731056&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "south-mountain-community-college",
      "poi_latitude": "33.381761",
      "poi_longitude": "-112.0322335",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 602-243-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4ef-771a-8612-f7f55f003baf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4ef-771a-8612-f7f55f003baf",
        "storage_key": "property/6767906449166443/019d02ca-e4ef-771a-8612-f7f55f003baf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD6bj0O4PK4cRsHyD43RJbZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f733c146-80e6-4739-9cd7-fea93dabb22c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Busy Bees South Phoenix Child Care Center",
      "poi_type": "Education",
      "poi_address": "3920 E Southern Ave, Phoenix, AZ 85040, USA",
      "poi_short_description": "Daycare center offering early childhood education that emphasizes social, emotional, physical, and intellectual development.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019f05f8-c53a-72d9-a34e-56307484f21a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f05f8-c53a-72d9-a34e-56307484f21a",
        "storage_key": "property/6767906449166443/019f05f8-c53a-72d9-a34e-56307484f21a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://busybeesusa.com/locations/southphoenix/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221625478425138618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "busy-bees-south-phoenix-child-care-center",
      "poi_latitude": "33.3929474",
      "poi_longitude": "-111.9964515",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-405-9585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4ef-771a-8612-f7f55f003baf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4ef-771a-8612-f7f55f003baf",
        "storage_key": "property/6767906449166443/019d02ca-e4ef-771a-8612-f7f55f003baf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4THQ4XQPK4cRutXISlKmfLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_3296e10a-473e-421c-a9a6-2c8a7295c0a2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Tutor Time on E. Baseline",
      "poi_type": "Education",
      "poi_address": "3316 E Baseline Rd, Phoenix, AZ 85042, USA",
      "poi_short_description": "Day care center featuring an exclusive school readiness pathway and developmentally appropriate programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019f05f8-c349-7180-9cdd-a02775b9e244.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f05f8-c349-7180-9cdd-a02775b9e244",
        "storage_key": "property/6767906449166443/019f05f8-c349-7180-9cdd-a02775b9e244.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.tutortime.com/your-local-school/phoenix-az-6088/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=6088",
      "poi_directions_map_url": "https://maps.google.com/?cid=4091741162567360741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tutor-time-on-e-baseline",
      "poi_latitude": "33.3787831",
      "poi_longitude": "-112.0093529",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 855-887-8945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-e4ef-771a-8612-f7f55f003baf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-e4ef-771a-8612-f7f55f003baf",
        "storage_key": "property/6767906449166443/019d02ca-e4ef-771a-8612-f7f55f003baf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3ZLDBoUPK4cR5eCri-jIyDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_e53704d7-b832-43b6-9468-45d73961aefa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "poi_name": "Oasis Water Park",
      "poi_type": "Entertainment",
      "poi_address": "8000 Arizona Grand Pkwy, Phoenix, AZ 85044, USA",
      "poi_short_description": "Arizona Grand Resort's on-property water park complete with a wave pool, slides, tubing & hot tub.",
      "poi_long_description": "Visitors say this water park offers a relaxing lazy river, a fun wave pool, and multiple slides, with plenty of seating and available towels. They also highlight the attentive lifeguards, clean restrooms, and the convenience of heated water during cooler seasons.\n\nSome reviews mention the food and drinks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019f05f8-c235-754d-9237-43f10a978f6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f05f8-c235-754d-9237-43f10a978f6c",
        "storage_key": "property/6767906449166443/019f05f8-c235-754d-9237-43f10a978f6c.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.arizonagrandresort.com/oasis-water-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14447697984055629090&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oasis-water-park",
      "poi_latitude": "33.3743769",
      "poi_longitude": "-111.971985",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 602-438-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-f268-7013-bd8e-3231cfe98e17",
        "storage_key": "property/6767906449166443/019d02ca-f268-7013-bd8e-3231cfe98e17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7Z5avQFK4cRIlXD8cSIgMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b31d5aaadc246c61f4993708",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0d26ba713dc153be0ea74e09",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_901a0c7f8deba9d4dd739a54",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_329694028662cb4eb3480021",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e90c921bc6f2e8f14beeedb7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b6cb80b017a4c5c00f6e0186",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_449b6419-8ff7-43ee-9e3a-0a771c9f2cff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "rating": "5.0",
      "name": "Jay Urias",
      "text": "John the maintenance guy did amazing job on replacing my Restroom vent. He made sure that we can test the product out to ensure that it was working properly. John very kind and courteous also left no mess behind which was a plus. The work order that we place was quick and fast to get this job completed. Extremely satisfied with our maintenance worker.",
      "date": "2025-08-14",
      "title": ""
    },
    {
      "id": "custom_45ff0291-6082-4ad5-9605-4011eab2de71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "rating": "5.0",
      "name": "Raelle Simmonds",
      "text": "Move in process was a breeze. I Love it here! Joe the Maintenance Guy is excellent at the work he does , the Office staff Claudia & Chasity are knowledgeable & helpful. Community is quiet at night. No BUG problems, No noise complaints whatsoever. I have a one bedroom & it’s very spacious. I think I’ll definitely be here for a while! Thanks Parc South Mountain. Excellent service",
      "date": "2025-01-23",
      "title": ""
    },
    {
      "id": "custom_771ba421-20ae-40e8-94a8-a778309d8c8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "rating": "5.0",
      "name": "Dewayne Winston",
      "text": "The maintenance guy John was awesome! He came through to change the locks, and explain the spot I was concerned about on my ceiling. Great conversation & he was very helpful. Also Go Cowboys!",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_692459db-9fad-4415-a2e1-92f94831c55e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "rating": "5.0",
      "name": "nicolepalsiss",
      "text": "Huge thanks to Joseph in the leasing office! I came in stressed and urgently needing a new place, and he instantly made me feel at home. The unit he showed me was perfect — I fell in love and applied right away. Joseph’s warmth and professionalism made all the difference!",
      "date": "2025-08-07",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_cb8a220b-917e-4155-b52e-5604ab094adc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cb-5db0-7699-ab14-6f4e9f4ff7e2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen and living area in an apartment",
        "public_id": "019d02cb-5db0-7699-ab14-6f4e9f4ff7e2",
        "storage_key": "property/6767906449166443/019d02cb-5db0-7699-ab14-6f4e9f4ff7e2.webp",
        "width": 1280,
        "height": 720
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 726 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=aZUD26PwWK2"
    },
    {
      "id": "custom_a1338567-f69d-487f-a0af-5d9a8aa0d3ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-0a80-74fd-bcd8-49106a4221f1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Community lounge area with pool table, seating, and bar.",
        "public_id": "019d02cc-0a80-74fd-bcd8-49106a4221f1",
        "storage_key": "property/6767906449166443/019d02cc-0a80-74fd-bcd8-49106a4221f1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vMssLhMZaEW"
    },
    {
      "id": "custom_f555f057-87fb-4dd1-b293-a40e10a73712",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166443/019d02cc-0a70-7498-8ae8-5303d8aa4873.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with modern equipment and a striking blue accent wall.",
        "public_id": "019d02cc-0a70-7498-8ae8-5303d8aa4873",
        "storage_key": "property/6767906449166443/019d02cc-0a70-7498-8ae8-5303d8aa4873.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vBWj1LzBA2q"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfe5-64e1-7405-89d4-b8a11209efb0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-parc-south-mountain-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-phoenix-az",
      "search_query": "apartments with in-unit laundry Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Near South Mountain",
      "h2_subtitle": "Looking for apartments with in-unit laundry in Phoenix, AZ? Parc South Mountain offers the perfect blend of convenience and modern living.",
      "page_copy": "Discover the convenience of living at Parc South Mountain, where apartments with in-unit laundry become a staple of everyday ease. Nestled in South Mountain Village, Phoenix, AZ, our community promises an elevated lifestyle with the inclusion of luxurious amenities. \n\nFrom gourmet kitchens featuring quartz countertops to plush designer carpeting, every detail is crafted for your comfort. Plus, enjoy the added convenience of covered parking and modern pendant lighting, creating a home that's both stylish and functional. Experience the best of Phoenix living with in-unit laundry facilities that meet your needs at Parc South Mountain.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apts in Phoenix - Parc South Mountain",
      "seo_description": "Find apartments with in-unit laundry in Phoenix, AZ, at Parc South Mountain. Enjoy modern living with top amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-south-mountain-village",
      "search_query": "pet friendly apartments South Mountain Village",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in South Mountain Village",
      "h2_subtitle": "Searching for pet friendly apartments in South Mountain Village? Parc South Mountain is the perfect home for you and your furry friends.",
      "page_copy": "Welcome to Parc South Mountain, where pet friendly living in South Mountain Village is made seamless and enjoyable. Our community in Phoenix, AZ, offers a warm welcome to you and your furry companions, ensuring every member of your household feels at home.\n\nBeyond accommodating pets, we offer an array of amenities such as covered parking and gourmet kitchens with quartz countertops. Relax in a stylish living space enhanced by modern pendant lighting and plush designer carpeting. Discover a pet-owner's paradise that promises comfort and style for everyone living at Parc South Mountain.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apts - Parc South Mountain",
      "seo_description": "Find pet friendly apartments in South Mountain Village at Parc South Mountain. Perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-phoenix-85040",
      "search_query": "resort style pool apartments Phoenix 85040",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments in Phoenix 85040",
      "h2_subtitle": "Experience luxury at our resort style pool apartments in Phoenix, 85040. Enjoy top-notch amenities at Parc South Mountain.",
      "page_copy": "Indulge in the luxury of resort style pool living at Parc South Mountain, perfectly situated in the heart of Phoenix, 85040. Our community offers more than just a home – it's a personal oasis where style meets comfort.\n\nEnjoy sun-soaked days by our impressive pool, and take advantage of our modern building features, including gourmet kitchens with quartz countertops, plush designer carpeting, and under-mount kitchen sinks. Residents can also benefit from covered parking and stylish pendant lighting. Embrace the lifestyle you deserve in an apartment setting that delivers the ultimate in relaxation and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments - Parc South Mountain",
      "seo_description": "Discover resort style pool apartments in Phoenix, 85040. Parc South Mountain offers unmatched amenities and luxurious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "luxury-apartments-gourmet-kitchens-maricopa-county",
      "search_query": "luxury apartments with gourmet kitchens Maricopa County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Gourmet Kitchens",
      "h2_subtitle": "Searching for luxury apartments with gourmet kitchens in Maricopa County? Parc South Mountain is your ideal destination.",
      "page_copy": "Immerse yourself in the luxury of Parc South Mountain, where gourmet kitchens define the ultimate culinary experience in Maricopa County. Located in Phoenix's scenic South Mountain Village, our apartments blend elegance with functionality.\n\nOur gourmet kitchens boast exquisite quartz countertops, modern pendant lighting, and sleek under-mount sinks, designed to satisfy every home chef’s dream. Complemented by plush designer carpeting and covered parking, our community provides a luxurious living experience that stands out in Maricopa County. Let Parc South Mountain be the setting of your dream home, where luxury and style converge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apts with Gourmet Kitchens - Parc South Mountain",
      "seo_description": "Explore luxury apartments with gourmet kitchens in Maricopa County at Parc South Mountain. Enjoy stylish living with top-of-the-line amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "gated-community-covered-parking-phoenix",
      "search_query": "gated community with covered parking Phoenix",
      "category": "Amenity",
      "h1_title": "Gated Community with Covered Parking in Phoenix",
      "h2_subtitle": "Discover the benefits of a gated community with covered parking in Phoenix at Parc South Mountain. Enjoy security and convenience all in one.",
      "page_copy": "Experience the perfect blend of security and convenience at Parc South Mountain, a premier gated community in Phoenix. Our thoughtfully designed apartments offer the added peace of mind that comes with a gated environment.\n\nAt Parc South Mountain, covered parking is just one of the many amenities enhancing your lifestyle. Enjoy our luxurious features like gourmet kitchens adorned with quartz countertops and chic modern pendant lighting. With plush designer carpeting, you can indulge in a stylish, comfortable living experience. Discover how a gated community with covered parking can transform your lifestyle in the heart of Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community with Covered Parking - Parc South Mountain",
      "seo_description": "Find a gated community with covered parking in Phoenix at Parc South Mountain. Enjoy enhanced security and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-mountain-village",
      "search_query": "one bedroom apartments south mountain village",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Mountain Village",
      "h2_subtitle": "Explore our one bedroom apartments in South Mountain Village, perfectly designed for comfort and style. Find your new home at Parc South Mountain.",
      "page_copy": "Nestled in the vibrant South Mountain Village, Parc South Mountain presents exquisite one bedroom apartments tailored for contemporary living. Our community is designed to provide the perfect blend of comfort and style.\n\nEach one bedroom apartment features gourmet kitchens equipped with quartz countertops, modern pendant lighting, and functional under-mount sinks. Enjoy plush designer carpeting throughout your home and the convenience of covered parking. Experience the charm and luxury of living in a one bedroom apartment at Parc South Mountain, where you're close to the best of South Mountain Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments - Parc South Mountain",
      "seo_description": "Discover one bedroom apartments in South Mountain Village at Parc South Mountain, offering luxury living with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-phoenix-az",
      "search_query": "two bedroom apartments phoenix az",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Phoenix, AZ",
      "h2_subtitle": "Explore the spacious two bedroom apartments in Phoenix, AZ at Parc South Mountain. Perfectly designed for modern living.",
      "page_copy": "Discover the perfect two bedroom apartment at Parc South Mountain in Phoenix, AZ, where modern design meets practical living. Our community offers beautifully crafted spaces that cater to your lifestyle needs, right in the heart of South Mountain Village.\n\nEach of our two bedroom apartments features luxurious amenities, including gourmet kitchens with stunning quartz countertops, under-mount sinks, and elegant pendant lighting. Plush designer carpeting and covered parking add an extra touch of comfort and convenience. Experience unparalleled living in Phoenix, AZ with our spacious two bedroom layouts at Parc South Mountain.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Phoenix, AZ - Parc South Mountain",
      "seo_description": "Find spacious two bedroom apartments in Phoenix, AZ at Parc South Mountain. Enjoy modern amenities and stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-maricopa-county",
      "search_query": "three bedroom apartments maricopa county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Discover spacious three bedroom apartments in Maricopa County at Parc South Mountain. Perfect for families and groups, offering modern amenities.",
      "page_copy": "If you're seeking three bedroom apartments in Maricopa County, look no further than Parc South Mountain. Our expansive layouts provide ample room for families or those just in need of extra space, all within a vibrant community setting.\n\nEach apartment boasts a gourmet kitchen with quartz countertops, adding a touch of elegance to daily meals. Modern pendant lighting and plush designer carpeting enhance the inviting atmosphere, while under-mount sinks offer added convenience. Benefit from covered parking and a serene gated environment, making Parc South Mountain the ideal place to call home in Maricopa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Maricopa County - Parc South Mountain",
      "seo_description": "Explore three bedroom apartments in Maricopa County at Parc South Mountain, featuring modern amenities and a spacious layout.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-near-arizona-state-university-tempe",
      "search_query": "apartments near arizona state university tempe",
      "category": "School",
      "h1_title": "Apartments Near Arizona State University Tempe",
      "h2_subtitle": "Find convenient apartments near Arizona State University Tempe at Parc South Mountain. Ideal for students and professionals alike.",
      "page_copy": "Parc South Mountain is your prime destination for finding apartments near Arizona State University Tempe. Our location offers easy access to campus life while providing a luxurious and comfortable home environment.\n\nEnjoy living in our well-appointed apartments, featuring gourmet kitchens with quartz countertops and modern pendant lighting. The convenience of covered parking and the elegance of plush designer carpeting make Parc South Mountain a standout choice. Whether you're a student or a professional seeking proximity to ASU Tempe, our community is designed to suit your needs perfectly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arizona State University Tempe - Parc South Mountain",
      "seo_description": "Discover apartments near ASU Tempe at Parc South Mountain. Perfect for students, offering modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-close-to-gateway-community-college-washington-phoenix",
      "search_query": "apartments close to gateway community college washington phoenix",
      "category": "School",
      "h1_title": "Apartments Close to Gateway Community College",
      "h2_subtitle": "Explore apartments close to Gateway Community College in Washington, Phoenix at Parc South Mountain. Enjoy a perfect blend of convenience and comfort.",
      "page_copy": "Looking for apartments close to Gateway Community College in Washington, Phoenix? Parc South Mountain offers the ideal living experience with easy access to the college and a suite of modern amenities to enhance your daily life.\n\nOur apartments feature gourmet kitchens with elegant quartz countertops and chic modern pendant lighting, creating a welcoming atmosphere for both studying and relaxation. Residents can also enjoy the benefits of covered parking and plush designer carpeting, providing a comfortable living environment. Choose Parc South Mountain and make your college experience truly memorable.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Gateway Community College Phoenix - Parc South Mountain",
      "seo_description": "Find convenient apartments near Gateway Community College in Phoenix at Parc South Mountain. Enjoy modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-near-banner-university-medical-center-phoenix",
      "search_query": "apartments near Banner University Medical Center Phoenix",
      "category": "Hospital",
      "h1_title": "Apartments Near Banner University Medical Center",
      "h2_subtitle": "Discover ideal apartments near Banner University Medical Center Phoenix at Parc South Mountain. Experience convenience and comfort close to work.",
      "page_copy": "For those seeking apartments near Banner University Medical Center Phoenix, Parc South Mountain provides the perfect blend of proximity and luxury. Our community ensures a comfortable living experience just a short distance from the medical center.\n\nEach apartment features modern amenities like gourmet kitchens with quartz countertops and attractive modern pendant lighting. With covered parking and plush designer carpeting, residents enjoy convenience and style in their homes. Parc South Mountain is the best choice for healthcare professionals and staff looking for quality living near Banner University Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Banner University Medical Center Phoenix - Parc South Mountain",
      "seo_description": "Explore apartments near Banner University Medical Center Phoenix at Parc South Mountain, offering convenient access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-close-to-phoenix-childrens-hospital-thomas-campus",
      "search_query": "apartments close to Phoenix Children's Hospital Thomas Campus South Mountain Village",
      "category": "Hospital",
      "h1_title": "Apartments Close to Phoenix Children's Hospital",
      "h2_subtitle": "Find your next home at Parc South Mountain with apartments close to Phoenix Children's Hospital Thomas Campus. Ideal for healthcare professionals.",
      "page_copy": "Searching for apartments close to Phoenix Children's Hospital Thomas Campus in South Mountain Village? Parc South Mountain offers ideal accommodations for healthcare professionals and families needing quick access to the hospital.\n\nOur community features modern and stylish amenities, including gourmet kitchens with quartz countertops and elegant modern pendant lighting. Residents benefit from covered parking and plush designer carpeting, making daily living both convenient and luxurious. Located near Phoenix Children's Hospital, Parc South Mountain is perfect for those who prioritize proximity and comfort in South Mountain Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Phoenix Children's Hospital - Parc South Mountain",
      "seo_description": "Discover Parc South Mountain with apartments near Phoenix Children's Hospital, offering modern living and quick access for professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-near-desert-botanical-garden-phoenix",
      "search_query": "apartments near desert botanical garden phoenix",
      "category": "Park",
      "h1_title": "Explore Apartments Near Desert Botanical Garden",
      "h2_subtitle": "Discover the beauty of the Desert Botanical Garden from our apartments near Phoenix's natural treasure, located at Parc South Mountain.",
      "page_copy": "Looking for stunning apartments near the Desert Botanical Garden in Phoenix? Parc South Mountain blends natural beauty with modern amenities, providing residents with a perfect base to explore Phoenix's ecological marvel.\n\nOur community offers stylish living spaces featuring gourmet kitchens with sleek quartz countertops and modern pendant lighting. Enjoy covered parking and the comfort of plush designer carpeting in your home. Whether you're a nature enthusiast or simply love the proximity to the garden's trails and exhibits, Parc South Mountain is an ideal choice for your new home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Desert Botanical Garden Phoenix - Parc South Mountain",
      "seo_description": "Explore Phoenix living at Parc South Mountain, with apartments close to the Desert Botanical Garden and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-close-to-papago-park-south-mountain-village",
      "search_query": "apartments close to papago park south mountain village",
      "category": "Park",
      "h1_title": "Apartments Close to Papago Park",
      "h2_subtitle": "Experience nature's beauty with apartments close to Papago Park in South Mountain Village. Perfect for outdoor enthusiasts.",
      "page_copy": "If you are searching for apartments close to Papago Park, look no further than Parc South Mountain in South Mountain Village. Our community provides an excellent blend of urban convenience and access to the natural beauty of nearby Papago Park.\n\nEnjoy the comforts of gourmet kitchens with quartz countertops and the elegance of modern pendant lighting. With plush designer carpeting and covered parking, you can relish both cleanliness and comfort in your home. Parc South Mountain is a superior choice for those who appreciate outdoor activities and the vibrant atmosphere of South Mountain Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Papago Park - Parc South Mountain",
      "seo_description": "Parc South Mountain offers apartments near Papago Park in South Mountain Village, combining modern living with natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-by-south-mountain-park-preserve",
      "search_query": "apartments by south mountain park and preserve maricopa county",
      "category": "Park",
      "h1_title": "Apartments by South Mountain Park & Preserve",
      "h2_subtitle": "Live close to nature with apartments by South Mountain Park in Maricopa County. Ideal for nature lovers and hikers.",
      "page_copy": "Seeking apartments by South Mountain Park and Preserve in Maricopa County? Parc South Mountain offers an ideal living experience for those who cherish the great outdoors right at their doorstep.\n\nAt Parc South Mountain, our amenities include gourmet kitchens with quartz countertops, under-mount kitchen sinks, and sophisticated modern pendant lighting. Residents also enjoy covered parking and luxurious designer carpeting, ensuring a comfortable lifestyle. Located conveniently in South Mountain Village, our community offers an excellent lifestyle choice for those who love exploring the nearby park and trails.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by South Mountain Park & Preserve - Parc South Mountain",
      "seo_description": "Discover Parc South Mountain, offering premium apartments near South Mountain Park & Preserve in Maricopa County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-near-phoenix-sky-harbor-airport",
      "search_query": "apartments near phoenix sky harbor international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Phoenix Sky Harbor Airport",
      "h2_subtitle": "Find your home in our apartments near Phoenix Sky Harbor International Airport, ideal for frequent travelers.",
      "page_copy": "For conveniently located apartments near Phoenix Sky Harbor International Airport, consider Parc South Mountain. This community offers top-notch amenities perfect for frequent travelers seeking easy access to air travel.\n\nOur apartments feature gourmet kitchens with quartz countertops and stylish modern pendant lighting. Enjoy the practicality of under-mount kitchen sinks and the comfort of plush designer carpeting. Located in the vibrant South Mountain Village, Parc South Mountain ensures you're just minutes away from both the airport and urban amenities, making it a prime choice for modern, connected living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Phoenix Sky Harbor Airport - Parc South Mountain",
      "seo_description": "Discover Parc South Mountain, offering convenient apartments near Phoenix Sky Harbor International Airport with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-by-terminal-3-station-phoenix",
      "search_query": "apartments by terminal 3 station phoenix az",
      "category": "Transit",
      "h1_title": "Apartments by Terminal 3 Station Phoenix",
      "h2_subtitle": "Convenience meets comfort with apartments by Terminal 3 Station in Phoenix, AZ. Perfect location for easy transit access.",
      "page_copy": "Looking for apartments by Terminal 3 Station in Phoenix, AZ? Parc South Mountain offers a seamless blend of modern living and transit convenience, making it an excellent home base for commuters and frequent travelers.\n\nEnjoy the luxurious amenities at Parc South Mountain, including gourmet kitchens with quartz countertops and chic modern pendant lighting. Covered parking and under-mount kitchen sinks enhance your living experience. Located in desirable South Mountain Village, our community offers easy access to Terminal 3 Station, ensuring your travels begin smoothly and stress-free.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Terminal 3 Station Phoenix - Parc South Mountain",
      "seo_description": "Parc South Mountain provides modern apartments by Terminal 3 Station in Phoenix, AZ, combining luxury living with transit convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-close-to-44th-st-washington-phoenix",
      "search_query": "apartments close to 44th st/washington phoenix",
      "category": "Transit",
      "h1_title": "Apartments Close to 44th St/Washington",
      "h2_subtitle": "Explore our apartments close to 44th St/Washington in Phoenix. Perfect for city explorers and urban lifestyles.",
      "page_copy": "Discover the ideal urban living experience at Parc South Mountain, where our apartments are located close to 44th St/Washington in Phoenix. This prime location provides easy access to city amenities and transportation.\n\nAt Parc South Mountain, you'll enjoy modern comforts such as gourmet kitchens featuring quartz countertops and stylish pendant lighting. With plush designer carpeting and covered parking, our community caters to your comfort. Situated in the vibrant South Mountain Village neighborhood, you have the city's entertainment and conveniences at your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to 44th St/Washington - Parc South Mountain",
      "seo_description": "Find modern and convenient apartments at Parc South Mountain, close to 44th St/Washington in Phoenix, ideal for urban lifestyles.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-near-44th-st-station-south-mountain",
      "search_query": "apartments near 44th st station south mountain village",
      "category": "Transit",
      "h1_title": "Apartments Near 44th St Station South Mountain",
      "h2_subtitle": "Experience seamless transit with our apartments near 44th St Station in South Mountain Village.",
      "page_copy": "Find the perfect blend of convenience and comfort with Parc South Mountain's apartments, located near 44th St Station in the vibrant South Mountain Village. This strategic location ensures you have quick access to transit, making it ideal for commuters and city explorers.\n\nOur community offers an array of superior amenities, including under-mount kitchen sinks and plush designer carpeting. The gourmet kitchens with quartz countertops and modern pendant lighting elevate your living experience. Enjoy all the conveniences South Mountain Village offers with easy connectivity to the rest of Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near 44th St Station South Mountain Village",
      "seo_description": "Discover Parc South Mountain's modern apartments near 44th St Station in South Mountain Village for easy transit and urban living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166443",
      "source": "generator",
      "page_item_url": "apartments-by-veterans-way-college-ave-maricopa",
      "search_query": "apartments by veterans way/college ave maricopa county",
      "category": "Transit",
      "h1_title": "Apartments by Veterans Way/College Ave",
      "h2_subtitle": "Find your new home at Parc South Mountain, offering apartments by Veterans Way/College Ave in Maricopa County.",
      "page_copy": "Experience modern living with Parc South Mountain’s apartments, conveniently situated by Veterans Way/College Ave in Maricopa County. This prime location offers excellent connectivity and access to nearby attractions, ideal for students and professionals alike.\n\nOur luxury community features gourmet kitchens with state-of-the-art quartz countertops and modern pendant lighting. Enjoy the comfort of plush designer carpeting and the convenience of covered parking. With under-mount kitchen sinks and a vibrant community atmosphere, Parc South Mountain offers the perfect balance of style and practicality in the desirable Maricopa County locality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Veterans Way/College Ave - Parc South Mountain",
      "seo_description": "Explore Parc South Mountain's apartments near Veterans Way/College Ave in Maricopa County, where modern conveniences meet prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5315"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425043"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=255e6a838246c692624ad44a6b5822bf710885d2d2ed204d6ca10ad0fb92a96565b9ddf45d5bf45e387618ea5975b4c0\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-55TBB7BS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "243PSM"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40248123705"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Parc South Mountain/scheduletourwidget/Hia3uUs94XFJA2koRV/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InNNYkVBdkNKVTczR1ZvYmJtd3U4M0E9PSIsInZhbHVlIjoiZzd3SWNobktzL0N0MXQ3TitMWCtUUT09IiwibWFjIjoiMmJkMzUwNDc0NzM3Y2RlZmRlNWFkZGE4MDQ4ZmNjNDY2OWNjZjZhZGFkZTUzZDNmNzFjNDVjYWFhMWMyYzA1YiJ9"
    }
  ],
  "custom_qb_id": "5315",
  "custom_repli_id": "18104425043",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=255e6a838246c692624ad44a6b5822bf710885d2d2ed204d6ca10ad0fb92a96565b9ddf45d5bf45e387618ea5975b4c0\"></script>",
  "custom_google_gtm_id": "GTM-55TBB7BS",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "243PSM",
  "custom_hubspot_company_id": "40248123705",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Parc South Mountain/scheduletourwidget/Hia3uUs94XFJA2koRV/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InNNYkVBdkNKVTczR1ZvYmJtd3U4M0E9PSIsInZhbHVlIjoiZzd3SWNobktzL0N0MXQ3TitMWCtUUT09IiwibWFjIjoiMmJkMzUwNDc0NzM3Y2RlZmRlNWFkZGE4MDQ4ZmNjNDY2OWNjZjZhZGFkZTUzZDNmNzFjNDVjYWFhMWMyYzA1YiJ9",
  "custom_audioeye_site_id": "ca9ed53b-d30f-4ae6-bda6-bdd90798313b",
  "custom_audioeye_site_hash": "2bd20a17df1fb8a76943da8ad4442460"
};

export const generatedAt = '2026-08-21T22:01:32.195Z';
